//import axios from 'axios'
import React, { useEffect, useState } from 'react'
import ModalCirugiaQuirofano from './cirugia/modalCirugia/ModalCirugiaQuirofano'
import ModalCirugiaReservadoPor from './cirugia/modalCirugia/ModalCirugiaReservadoPor'
import ModalCirujanoCargo from './cirugia/modalCirugia/ModalCirujanoCargo'
import ModalEntidadAseguradora from './cirugia/modalCirugia/ModalEntidadAseguradora'
import ModalCirugiaPalabraClave from './cirugia/modalCirugia/ModalCirugiaPalabraClave'
import ModalHemoderivados from './cirugia/modalCirugia/ModalHemoderivados'
import ModalCirugiaDXPreoperatorio from './cirugia/modalCirugia/ModalCirugiaDXPreoperatorio'
import ModalCirugiaReservadoPorEspecialidad from './cirugia/modalCirugia/ModalCirugiaReservadoPorEspecialidad'
import ModalCirugiaCirujanoCargoEspecialidad from './cirugia/modalCirugia/ModalCirugiaCirujanoCargoEspecialidad'
import { getObtenerTodasOpcionesCirugia, postButtonModificarCirugia, postCirugiaEspecialidad, postCirugiaModificar, postCirugiaReservadoPor, postHorarioQuirofanos, postInsertQuirofanos, postInsertTurqui, postSelectTurquiValidarSiExiste, postUltimoConsecutivoTurquiProgramacionCirugia, postUpdateTurqui, postVerificarQuirofanoOcupado } from '../services/PaginaRuta'
import ModalProcedimiento from './cirugia/modalProcedimiento/ModalProcedimiento'
import SuccessFul from './mensaje/SuccessFul'
import ErrorCirugia from './mensaje/ErrorCirugia'
//import Loading from './Loading'
import { fechaActual } from '../hooks/UseDate'
import ModalOtroCirujanoCargo from './cirugia/modalCirugia/ModalOtroCirujanoCargo'
import ModalOtroCirujanoCargoEspecialidad from './cirugia/modalCirugia/ModalOtroCirujanoCargoEspecialidad'
//import { useForm } from "react-hook-form";

const ModalCirugiaTabs = ({ setModalOn, setChoice, user, color, passDataActualizaTablaPacientes }) => {
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    //console.log(usuarioInfo.Sede = 001, 'usuarioInfoStr cirugia') // usuarioInfo.Empresa = 1  usuarioInfo.UsuarioEncriptado
    const [openTab, setOpenTab] = useState(1);
    //console.log(watch("Empresa"))
    //
    const [dataHorariosQuirofanos, setdataHorariosQuirofanos]=useState({
        CoHSalQui:'',
        CoHEntQui:'',
        dia:'',
        idQuirofano:''
    })
    const [dataEstados, setdataEstados]=useState('')
    const [dataUser, setDataUser] = useState([])
    const [fechaCirugia, setfechaCirugia]=useState('')
    const [fechaF, setFechaF] = useState('')
    const [fechaI, setFechaI] = useState('')
    const [errorFechaI, setErrorFechaI]= useState('')
    const [errorFechaF, setErrorFechaF]= useState('')
    const [errorDxPreoperatorio, seterrorDxPreoperatorio]=useState('')
    const [edadPaciente, setEdadPaciente] = useState('')
    const [years, setYears] = useState('AÑOS')
    const [reservaCama, setReservaCama] = useState()
    const [reqValoracionPreanestesica, setReqValoracionPreanestesica] = useState()
    const [reqMaterialesEspeciales, setReqMaterialesEspeciales] = useState()
    const [reqDispEquiposEspeciales, setReqDispEquiposEspeciales] = useState()
    const [hemoderivadosChe, setHemoderivadosChe] = useState()
    const [quirofanoUserError, setQuirofanoUserError] = useState('')
    const [horaInicialUserError, setHoraInicialUserError] = useState('')
    const [horaI, setHoraI] = useState('')
    const [horaF, setHoraF] = useState('')
    const [horaFinalUserError, setHoraFinalUserError] = useState('')
    const [fechaNacimientoUser, setFechaNacimientoUser] = useState('')
    const [opcionUserError, setOpcionUserError] = useState('')
    const [codigoCirujanoCargoUserError, setCodigoCirujanoCargoUserError] = useState('')
    const [tipoDeAnestesiaUser, setTipoDeAnestesiaUser] = useState('')
    const [estadoDelPacienteUser, setEstadoDelPacienteUser]= useState('')
    const [tipoCamaDxUser, setTipoCamaDxUser] = useState('')
    const [tipoCamaCXTextAreaUser, setTipoCamaCXTextAreaUser]= useState('')
    const [reqDispEquiposEspecialesTextArea, setReqDispEquiposEspecialesTextArea] = useState('')
    const [reqDispEquiposEspecialesUserTextArea, setreqDispEquiposEspecialesUserTextArea] = useState('')
    const [cantidadUser, setCantidadUser] = useState('')
    const [volmLUsuser, setVolmL] = useState('')
    const [observacionesUser, setObservacionesUser]= useState('')
    const [obsQuirurgicas, setObsQuirurgicas]= useState('')
    const [opcion, setOpcion] = useState('')
    const [lateralidadUser, setLateralidadUser] = useState('')
    const [estadoPacienteError, setEstadoPacienteError] = useState('')
    const [modalOnErrorCirugia, setmodalOnErrorCirugia]=useState(false)
    const [calcularDuracionHora, setcalcularDuracionHora]= useState('')
    const [calcularDurarionMinutos,setCalcularDuracionMinutos]=useState('')
    const [errorDataQuirofanosOcupados,seterrorDataQuirofanosOcupados]=useState([])
    const [errorReservadoPor,seterrorReservadoPor]=useState('')
    const [loading,setloading]=useState(true)
    const [dataOpcionCirugia, setdataOpcionCirugia]=useState([])

    //boton guardar
    const [guardadoExitosamente, setGuardadoExitosamente] = useState(false)
    
    //Dieta
    const [blanda, setBlanda] = useState(false)
    const [liquida, setLiquida] = useState(false)
    const [corriente, setCorriente] = useState(false)
    const [hiposodica, setHiposodica] = useState(false)
    const [ayuno, setAyuno] = useState(false)
    const [enemaEvacuador, setEnemaEvacuador] = useState(false)
    const [premedicacion, setPremedicacion] = useState(false)
    const [acompanante, setAcompanante] = useState(false)
    const [rasurada, setRasurada] = useState(false)
    const [seisHorasAntes, setSeisHorasAntes] = useState(false)
    const [ochoHorasAntes, setOchoHorasAntes] = useState(false)
    const [doceHorasAntes, setDoceHorasAntes] = useState(false)
    const [veinteCuatroHorasAntes, setVeinteCuatroHorasAntes] = useState(false)
    const [validacionesDisabledHoraSeis, setvalidacionesDisabledHoraSeis] = useState(false)
    const [validacionesDisabledHoraOcho, setvalidacionesDisabledHoraOcho] = useState(false)
    const [validacionesDisabledHoraDoce, setvalidacionesDisabledHoraDoce] = useState(false)
    const [validacionesDisabledHoraVeintiCuatro, setvalidacionesDisabledHoraVeintiCuatro] = useState(false)
    const [isCheckedNinguna, setIsCheckedNinguna] = useState(false);
    //const [textAreaTodaDieta, setTextAreaTodaDieta] = useState('')

    //VARIABLES NO USADAS
    const [HCFcHrOrdUser, setHCFcHrOrdUser] = useState('')
    const [HCPrctpopUser, setHCPrctpopUser] = useState('')
    const [INSCODIUser, setINSCODIUser] =useState('')
    const [IdCirugiasUser, setIdCirugiasUser] =useState('')
    const [MPCeduUser, setMPCeduUser] =useState('')
    const [MPSexoUser, setMPSexoUser] =useState('')
    const [PNmPrCnfUser, setPNmPrCnfUser] =useState('')//duda
    const [PPersCnfUser, setPPersCnfUser] =useState('')
    const [PROCODHEMUser, setPROCODHEMUser] =useState('')
    const [PROHEMCIRUser, setPROHEMCIRUser] =useState('')
    const [PROINSCIRUser, setPROINSCIRUser] =useState('')
    const [PUsrConfUser,setPUsrConfUser] =useState('')
    const [PfcHrCnfUser, setPfcHrCnfUser] =useState('')
    const [ProCEmpUser, setProCEmpUser] =useState('')
    const [ProCSedeUSer, setProCSedeUser] =useState('')
    const [ProCitEstUser, setProCitEstUser] =useState('')
    const [ProCitNumUSer, setProCitNumUser] =useState('')
    const [ProCodHDUser, setProCodHDUser] =useState('')
    const [ProEstaUser, setProEstaUser] =useState('')
    const [ProFSepUser, setProFSepUser] = useState('')
    const [ProFecSRUser, setProFecSRUser] =useState('')
    const [ProFliCxUser, setProFliCxUser]=useState('')
    const [ProFliSolUser, setProFliSolUser]=useState('')
    const [ProHSepUser, setProHSepUser]=useState('')
    const [ProMtCnTpUser, setProMtCnTpUser]=useState('')
    const [ProNomsepUser, setProNomsepUser] =useState('')
    const [ProRegOpeUser, setProRegOpeUser]=useState('')
    const [ProUserUser, setProUserUser]=useState('')
    const [ProViaUser, setProViaUSer]=useState('')

    const [textAreaDieta, setTextAreaDieta] = useState('')
    //Modal Cirujano a cargo
    const [modalOnCirujanoCargo, setModalOnCirujanoCargo] = useState(false)
    const [choiceCirujanoCargo, setChoiceCirujanoCargo] = useState(false)
    const [dataChildCirujanoACargo, setDataChildCirujanoACargo] = useState({
        codigoMedicoEs:'',
        nombreMedicoEs:'',
        codigoEspecialidad:'',
        nombreEspecialidad:''
    })
    //Modal cirujano a cargo otro
    const [nuevoCiruganoACargo, setnuevoCiruganoACargo]=useState(false)
    const [modalOnOtroCirujanoCargo, setmodalOnOtroCirujanoCargo]=useState(false)
    const [modalOnOtraEspecialidad, setmodalOnOtraEspecialidad]=useState(false)
    const [dataOtroCirujanoCargo, setdataOtroCirujanoCargo]=useState({
        codigoMedicoEs:'',
        nombreMedicoEs:'',
        codigoEspecialidad:'',
        nombreEspecialidad:''
    })


    //Modal Quirofano
    const [modalOnCirugiaQuirofano, setModalOnCirugiaQuirofano] = useState(false)
    const [choicerCirugiaQuirofano, setChoicerCirugiaQuirofano] = useState(false)
    const [dataChildQuirofano, setDataChildQuirofano] = useState({
        codigoQuirofano:'',
        descripcionQuirofano: '',
        sedeQuirofano:''
    })
    //Modal Reservado por
    const [modalOnCirugiaReservadoPor, setModalOnCirugiaReservadoPor] = useState(false)
    const [choiceCirugiaReservadoPor, setChoiceCirugiaReservadoPor] = useState(false)
    const [dataChildReservadorPor, setdataChildReservadorPor] = useState({
        codigoMedicoEs:'',
        nombreMedicoEs:'',
        codigoEspecialidad:'',
        nombreEspecialidad:''
    })
    //Modal Entidad Aseguradora
    const [modalOnCirugiaEntidadAseguradora, setModalOnCirugiaEntidadAseguradora] = useState(false)
    const [choiceCirugiaEntidadAseguradora, setChoiceCirugiaEntidadAseguradora] = useState(false)
    const [dataChildEntidadAseguradora, setdataChildEntidadAseguradora]=useState({
        MENNIT:'',
        MENOMB:''
    })
    //Modal Palabra Clave
    const [modalOnCirugiaPalabraClave,setModalOnCirugiaPalabraClave] = useState(false)
    const [choiceCirugiaPalabraClave, setChoiceCirugiaPalabraClave] = useState(false)
    //Modal Hemoderivados
    const [modalOnCirugiaHemoderivados, setModalOnCirugiaHemoderivados] = useState(false)
    const [choiceCirugiaHemoderivados, setChoiceCirugiaHemoderivados] = useState(false)
    //Modal DX Preoperatorio
    const [modalOnCirugiaDXPreoperatorio, setModalOnCirugiaDXPreoperatorio] = useState(false)
    const [choiceCirugiaDXPreoperatorio, setChoiceCirugiaDXPreoperatorio] = useState(false)
    const [dataChildPreoperatorio, setDataChildPreoperatorio] = useState({
        DMCodi: '',
        DMNomb: '',
        PClCod: ''
    })
    //Modal Reservado Por Especialidad
    const [modalOnCirugiaReservadoPorEspecialidad, setModalOnCirugiaReservadoPorEspecialidad] = useState(false)
    const [choiceCirugiaReservadoPorEspecialidad, setChoiceCirugiaReservadoPorEspecialidad] = useState(false)
    const [dataChildReservadoPorEspecialidad, setDataChildReservadoPorEspecialidad] = useState({
        codigoEspecialidad: '',
        descripcionEspecialidad: '',
        medicoCodigoEspecialidad: ''
    })
    //Modal Cirujano a Cargo Especialidad
    const [modalOnCirugiaCirujanoCargoEspecialidad, setModalOnCirugiaCirujanoCargoEspecialidad] = useState(false)
    const [choiceCirugiaCirujanoCargoEspecialidad, setChoiceCirugiaCirujanoCargoEspecialidad] = useState(false)
    const [dataChildCirujanoCargoEspecialidad, setDataChildCirujanoCargoEspecialidad] = useState({
        codigoEspecialidad: '',
        descripcionEspecialidad: '',
        medicoCodigoEspecialidad: ''
    })

    //Pequeña Cirugía
    const [dataPequenaCirugia, setDataPequenaCirugia] = useState("N")

    //fechas actuales
//     const [fechaInicio, setFechaInicio] = useState("");
//   const [fechaFinal, setFechaFinal] = useState("");
//   const [fechaActual, setFechaActual] = useState("");

    // Estado que manejará la lista de médicos con identificador único
  const [medicos, setMedicos] = useState([]);

  // Estado para gestionar el próximo ID secuencial
  const [nextId, setNextId] = useState(1);

  //guardar id cirujano
  const [idInput, setidInput]=useState('')

  // Función para manejar el cambio en los inputs
//   const handleInputChange = (id, event) => {
//     const values = medicos.map((medico) =>
//       medico.id === id ? { ...medico, [event.target.name]: event.target.value } : medico
//     );
//     setMedicos(values);
//   };

  // Función para agregar un nuevo campo de médico con un id secuencial
  const handleAddFields = () => {
    setMedicos((prevMedicos) => [
      ...prevMedicos,
      { idCirujano: nextId,
        codigo_medico:'',
        nombre_medico:'',
        codigo_especialidad:'',
        nombre_especialidad:''
       },  // Asignamos el siguiente ID secuencial
    ]);
    setNextId(nextId + 1);  // Incrementamos el ID para el próximo médico
  };

  // Función para eliminar un campo de médico usando su ID único
  const handleRemoveFields = (id) => {
    const newValues = medicos.filter((medico) => medico.idCirujano !== id);
    setMedicos(newValues);
  };

  // Función para manejar el submit del formulario
//   const handleSubmit = (event) => {
//     event.preventDefault();
//     console.log('Médicos:', medicos);
//     // Aquí puedes hacer lo que necesites con los datos, como enviarlos a un API
//   };

       
        //console.log(medicos, ' medicos nuevo')
    // formulario
    //const [empresaModificar, setEmpresaModificar] = useState('')
    //Formulario validación    
    // const { register, handleSubmit, watch, formState: { errors } } = useForm();
    //     {
    //     defaultValues: {
    //         Empresa: dataUser.ProEmpCod
    //       }
    // }
    
    // const onSubmit = data => setDataUser(data);
    // console.log(dataUser);
    ///

    //cirugano a cargo otro
    const handleClickCiruganoCargoOtro=()=>{
        setnuevoCiruganoACargo(!nuevoCiruganoACargo)
    }

    // const otroCirujanoACargo=()=>{
    //     setmodalOnOtroCirujanoCargo(true)
    // }
    const otroCirujanoACargo=(id)=>{
        setidInput(id)
        setmodalOnOtroCirujanoCargo(true)
    }

    const otraEspecialidadACargo=(id)=>{
        setidInput(id)
        setmodalOnOtraEspecialidad(true)
    }

    const passDataOtroCirujanoCargo=(data)=>{
        const values = medicos.map((medico) =>
            medico.idCirujano === idInput ? { 
                ...medico,  
                codigo_medico:data.codigoMedicoEs,
                nombre_medico:data.nombreMedicoEs,
                codigo_especialidad:data.codigoEspecialidad,
                nombre_especialidad:data.nombreEspecialidad } : medico
          );
          setMedicos(values);
        setdataOtroCirujanoCargo({
            codigoMedicoEs:data.codigoMedicoEs,
            nombreMedicoEs:data.nombreMedicoEs,
            codigoEspecialidad:data.codigoEspecialidad,
            nombreEspecialidad:data.nombreEspecialidad
        })
        setmodalOnOtroCirujanoCargo(false)
    }

    const handleClickBorrarCirujanoCargoOtro=()=>{
        setdataOtroCirujanoCargo({
            codigoMedicoEs:'',
            nombreMedicoEs:'',
            codigoEspecialidad:'',
            nombreEspecialidad:''
        })
    }

    const passDataEspecialidadOtroCirujanoACargo=(data)=>{
        const values = medicos.map((medico) =>
            medico.idCirujano === idInput ? { 
                ...medico,                  
                codigoEspecialidad:data.codigoEspecialidad,
                nombreEspecialidad:data.nombreEspecialidad } : medico
          );
          setMedicos(values);
        // setdataOtroCirujanoCargo({
        //     codigoMedicoEs:dataOtroCirujanoCargo.codigoMedicoEs,
        //     nombreMedicoEs:dataOtroCirujanoCargo.nombreMedicoEs,        
        //     codigoEspecialidad: data.codigoEspecialidad,
        //     nombreEspecialidad: data.descripcionEspecialidad
        // })
        setmodalOnOtraEspecialidad(false)

    }

    //modificar el formulario

    const handleModificar = (e) =>{
        e.preventDefault();
        //Empresa
        let ProEmpCod = e.target.empresa.value
        //Sede ProCSede, ProMCDpto
        let ProMCDpto = e.target.sede.value
        //N° Cirugía
        let ProCirCod = e.target.nCirugia.value
        //N° Autorización
        let ProCirAut = e.target.nAutorizacion.value
        //Estado
        //let estado_paciente= e.target.estadoPaciente.value
        //N° Quirófano
        let ProCons = e.target.nQuirofano.value
        //Quirófano
        let ProNcons = e.target.nombreQuirofano.value
        //Sede Quirófano
        let ProSedQr = e.target.sedeQuirofano.value
        //Indi. Oportunidad
        let ProIndOpu = e.target.indOportunidad.value
        //Fecha Inicial
        let ProFec = e.target.fechaInicial.value +' 00:00:00.000'
        //Hora Inicial
        let ProHorI = e.target.horaInicial.value + ':00'
        //Fecha Final
        let ProFecF = e.target.fechaFinal.value + ' 00:00:00.000'
        //Hora Final
        let ProHorF = e.target.horaFinal.value + ':00'
        //Duracion Hora
        let ProDurHr = e.target.horaDuracion.value//arreglar
        //Duracion Minutos
        let ProDurMn = e.target.minutoDuracion.value//arreglar
        //N° del Documento
        let HISCKEY = e.target.numeroDocumento.value
        //Tipo de Documento
        let MPTDoc = e.target.tipoDocumento.value
        //Nombre del Paciente
        let MPNOMC = e.target.nombrePaciente.value
        //Edad (fecha de nacimiento)
        let MPFchN = fechaNacimientoUser 
        //Opción
        let ProSit = opcion 
        //Reservado Por
        let ProPerSep = e.target.coReservadoPor.value
        //Reservado Por Especialidad
        let ProEspSep = e.target.reservadoPorEspecialidad.value
        //Cirujano a Cargo
        let ProPerSe1 = e.target.codigoCirujanoCargo.value
        //Cirujano a Cargo Especialidad        
        let ProEspSe1 = e.target.codigoCirujanoCargoEspecialidad.value
        //Entidad Aseguradora
        let ProEPS = e.target.nombreEPSEntidadAseguradora.value
        //Entidad Aseguradora nombre
        let ProNEPS = e.target.nEPS.value
        //Lateralidad
        let ProLat = lateralidadUser  
        //Req Valoración Preanestésica?     
        let ProRValAn = '' //S - N
        if(reqValoracionPreanestesica){
            ProRValAn = 'S'
        }else if(!reqValoracionPreanestesica){
            ProRValAn = 'N'
        }
        //Tipo de Anestesia
        let ProTpAnst = tipoDeAnestesiaUser
        //Estado del Paciente
        let ProVivo = estadoDelPacienteUser//0validar-1-2-3-4-5-6
        //DX Preoperatorio
        let ProDxppal = dataChildPreoperatorio.DMCodi
        //DX Preoperatorio nombre
        let ProDN1 = dataChildPreoperatorio.DMNomb
        //Reserva Cama?
        let ProResCam = ''
        if(reservaCama){
            ProResCam = 'S'
        }else if(!reservaCama){
            ProResCam = 'N'
        }
        //Tipo de Cama CX
        let ProTipCam = tipoCamaDxUser
        //Tipo de Cama CX textArea
        let ProObRCam = tipoCamaCXTextAreaUser
        //Req. Materiales Especiales?
        let ProReMaE = ''
        if(reqMaterialesEspeciales){
            ProReMaE = 'S'
        }else if(!reqMaterialesEspeciales){
            ProReMaE = 'N'
        }
        //Req. Materiales Especiales? textArea
        let ProObMaE = reqDispEquiposEspecialesTextArea
        //Req. Disp. Equipos Especiales?
        let ProDispEE = ''
        if(reqDispEquiposEspeciales){
            ProDispEE = 'S'
        }else if(!reqDispEquiposEspeciales){
            ProDispEE = 'N'
        }
        //Req. Disp. Equipos Especiales?
        let ProObsEE = reqDispEquiposEspecialesUserTextArea
        //Dieta textArea
        let ProOBs1 = textAreaDieta
        //Dieta Ninguna, Blanda, Líquida, etc
        //FALTA VALIDAR
        //Obs. Quirurgicas
        let ProObsT = obsQuirurgicas
        //hemo
        let ProReqHD = ''
        if(hemoderivadosChe){
            ProReqHD = 'S'
        }else if(!hemoderivadosChe){
            ProReqHD = 'N'
        }
        //cantidad inputtext
        let PROCANORD= cantidadUser
        //vol mL inputtext
        let PROVOLORD= volmLUsuser
        //observaciones
        let ProObsHD = observacionesUser
        //console.log(ProReqHD, 'handleModificar')

        /////VARIABLES NO USADAS
        let HCFcHrOrd = HCFcHrOrdUser
        let HCPrctpop=HCPrctpopUser 
        let INSCODI= INSCODIUser
        let IdCirugias=IdCirugiasUser
        let MPCedu= MPCeduUser
        let MPSexo= MPSexoUser
        let PNmPrCnf= PNmPrCnfUser
        let PPersCnf= PPersCnfUser
        let PROCODHEM= PROCODHEMUser
        let PROHEMCIR= PROHEMCIRUser
        let PROINSCIR= PROINSCIRUser
        let PUsrConf= PUsrConfUser
        let PfcHrCnf= PfcHrCnfUser
        let ProCEmp= ProCEmpUser
        let ProCSede= ProCSedeUSer
        let ProCitEst= ProCitEstUser
        let ProCitNum= ProCitNumUSer
        let ProCodHD= ProCodHDUser
        let ProEsta= ProEstaUser
        let ProFSep= ProFSepUser
        let ProFecSR= ProFecSRUser
        let ProFliCx= ProFliCxUser
        let ProFliSol= ProFliSolUser
        let ProHSep= ProHSepUser
        let ProMtCnTp= ProMtCnTpUser
        let ProNomsep= ProNomsepUser
        let ProRegOpe= ProRegOpeUser
        let ProUser= ProUserUser
        let ProVia= ProViaUser

        //cambiar estado
        let nuevoEstado=''

        if(parseInt(ProEsta) === 6 ){
            console.log('6 entro')
            nuevoEstado =  '1'
        }else if(parseInt(ProEsta) === 2){
            console.log('2 entro')
            nuevoEstado =  ProEsta
        }else if(parseInt(ProEsta) === 7){
            console.log('7 entro')
            nuevoEstado =  '1'
        }else if(parseInt(ProEsta) === 8){
            nuevoEstado =  ProEsta
        }else if(parseInt(ProEsta) === 1){
            nuevoEstado =  ProEsta
        }

        const body ={
            ProEmpCod: ProEmpCod,
            ProMCDpto: ProMCDpto,
            ProCirCod: ProCirCod,
            ProCirAut: ProCirAut,
            //estado_paciente: estado_paciente,
            ProCons: ProCons,
            ProNcons: ProNcons,
            ProSedQr: ProSedQr,
            ProIndOpu: ProIndOpu,
            ProFec: ProFec,
            ProHorI: ProHorI,
            ProFecF: ProFecF,
            ProHorF: ProHorF,
            ProDurHr: ProDurHr,
            ProDurMn: ProDurMn,
            HISCKEY: HISCKEY,
            MPTDoc: MPTDoc,
            MPNOMC: MPNOMC,
            MPFchN: MPFchN,
            ProSit: ProSit,
            ProPerSep: ProPerSep,
            ProEspSep: ProEspSep,
            ProPerSe1: ProPerSe1,
            ProEspSe1: ProEspSe1,
            ProEPS: ProEPS,
            ProNEPS:ProNEPS,
            ProLat: ProLat,
            ProRValAn: ProRValAn,
            ProTpAnst: ProTpAnst,
            ProVivo: ProVivo,
            ProDxppal: ProDxppal,
            ProDN1: ProDN1,
            ProResCam: ProResCam,
            ProTipCam: ProTipCam,
            ProObRCam: ProObRCam,
            ProReMaE: ProReMaE,
            ProObMaE: ProObMaE,
            ProDispEE: ProDispEE,
            ProObsEE: ProObsEE,
            ProOBs1: ProOBs1,
            ProObsT: ProObsT,
            ProReqHD: ProReqHD,
            PROCANORD: PROCANORD,
            PROVOLORD: PROVOLORD,
            ProObsHD: ProObsHD,
            HCFcHrOrd: HCFcHrOrd,
            HCPrctpop: HCPrctpop,
            INSCODI: INSCODI,
            IdCirugias:IdCirugias,
            MPCedu: MPCedu,
            MPSexo: MPSexo,
            PNmPrCnf: PNmPrCnf,
            PPersCnf: PPersCnf,
            PROCODHEM: PROCODHEM,
            PROHEMCIR: PROHEMCIR,
            PROINSCIR: PROINSCIR,
            PUsrConf: PUsrConf,
            PfcHrCnf: PfcHrCnf,
            ProCEmp: ProCEmp,
            ProCSede: ProCSede,
            ProCitEst: ProCitEst,
            ProCitNum: ProCitNum,
            ProCodHD: ProCodHD,
            ProEsta: nuevoEstado,
            ProFSep: ProFSep,
            ProFecSR: ProFecSR,
            ProFliCx: ProFliCx,
            ProFliSol: ProFliSol,
            ProHSep: ProHSep,
            ProMtCnTp: ProMtCnTp,
            ProNomsep: ProNomsep,
            ProRegOpe: ProRegOpe,
            ProUser: ProUser,
            ProVia: ProVia,
            ProPerSe2:dataOtroCirujanoCargo.codigoMedicoEs,
            ProEspSe2:dataOtroCirujanoCargo.codigoEspecialidad,
            MPNOMC:dataUser.MPNOMC,
            cirujanosProcedimiento:medicos,
            PequenaCirugia: dataPequenaCirugia
        }
        //console.log(body,'bodyyyyyyy')
        
        // aqui validamos los quirofanos que esten disponibles para su uso
        const validarQuirofano={
            ProEmpCod:usuarioInfo.Empresa            ,
            ProMCDpto:usuarioInfo.Sede,
            ProEsta:'3',
            ProFec:e.target.fechaInicial.value,
            ProFecF:e.target.fechaFinal.value,
            ProCons: e.target.nQuirofano.value,
            ProSedQr:usuarioInfo.Sede
          }
          //console.log(validarQuirofano,'VALIDATE')
          let quirofanoError=''
          postVerificarQuirofanoOcupado(validarQuirofano).then((res)=>{
            //console.log(res.data,'QUIROFANOS OCUPADOS')
            let inputFechaInicial = new Date(`${e.target.fechaInicial.value} ${e.target.horaInicial.value}:00`).getTime();
            inputFechaInicial = inputFechaInicial + 60000
            let inputFechaFinal = new Date(`${e.target.fechaFinal.value} ${e.target.horaFinal.value}:00`).getTime();
            inputFechaFinal = inputFechaFinal - 60000
            let quirofanoOcupados= res.data.find((validar)=>{
                
                if(parseInt(validar.ProCirCod) !== parseInt(e.target.nCirugia.value)){
                    //console.log(validar,'IMPORRRRRRRRRRRRRTANTEEEEEEEEE')
                    let quirofanoFechaInicial = new Date(`${validar.ProFec.split(' ')[0]} ${validar.ProHorI}`).getTime();
                    let quirofanoFechaFinal = new Date(`${validar.ProFecF.split(' ')[0]} ${validar.ProHorF}`).getTime();
                    return Math.min(inputFechaInicial, inputFechaFinal) <= Math.max(quirofanoFechaInicial, quirofanoFechaFinal) && Math.max(inputFechaInicial, inputFechaFinal) >= Math.min(quirofanoFechaInicial, quirofanoFechaFinal)           
                  
                }
                
               })
               //console.log(quirofanoOcupados,'res.data[0].ProCirCod')
               // console.log(e.target.nCirugia.value,'e.target.nCirugia.value')
               
               if(quirofanoOcupados && quirofanoOcupados.ProCirCod !== e.target.nCirugia.value ) {
                //console.log(quirofanoOcupados,'quirofanoOcupados')
                //console.log(quirofanoOcupados.ProCirCod,'res.data[0].ProCirCod')
                //console.log(e.target.nCirugia.value,'e.target.nCirugia.value')
                //if()
                setdataHorariosQuirofanos({
                    CoHSalQui:'',
                    CoHEntQui:'',
                    dia:'',
                    idQuirofano:''
                })
                seterrorDataQuirofanosOcupados(quirofanoOcupados)
                setmodalOnErrorCirugia(true)
                quirofanoError = 'Error'
               }else{
                quirofanoError = ''
                seterrorDataQuirofanosOcupados('')
                //aqui validamos los horarios de los quirofanos
                let inputFechaInicial = new Date(`${e.target.fechaInicial.value} ${e.target.horaInicial.value}:00`)
          let diaQuirofano = inputFechaInicial.getDay()
          let quirofanoErrorHorario=''
            const horario={
            ConsCod: e.target.nQuirofano.value,//passDataQuirofanoN.codigoQuirofano,
            ConsDia:inputFechaInicial.getDay()+1
            }
            console.log(horario,'horario')
        postHorarioQuirofanos(horario).then((res)=>{
        //console.log(res.data,'horarios')
        let dataH= res.data[0]
        
        let inputFechaInicial = new Date(`${e.target.fechaInicial.value} ${e.target.horaInicial.value}:00`).getTime();
        inputFechaInicial = inputFechaInicial + 60000
        let inputFechaFinal = new Date(`${e.target.fechaFinal.value} ${e.target.horaFinal.value}:00`).getTime();
        inputFechaFinal = inputFechaFinal - 60000
        

        let quirofanoOcupados= false
        // res.data.find((validar)=>{
            
        //     let quirofanoFechaInicial = new Date(`${e.target.fechaInicial.value} ${validar.CoHEntQui}`).getTime();
        //     let quirofanoFechaFinal = new Date(`${e.target.fechaFinal.value} ${validar.CoHSalQui}`).getTime();
            
        //     return   quirofanoFechaInicial <= inputFechaInicial  && inputFechaFinal >= quirofanoFechaFinal  ||      quirofanoFechaInicial >= inputFechaInicial  && inputFechaFinal <= quirofanoFechaFinal 
        // })
        if(quirofanoOcupados) {
            let dia=''
            if(diaQuirofano == '1'){
                dia='Lunes'
            }else if(diaQuirofano == '2'){
                dia='Martes'
            }else if(diaQuirofano == '3'){
                dia='Miercoles'
            }else if(diaQuirofano == '4'){
                dia='Jueves'
            }else if(diaQuirofano == '5'){
                dia='Viernes'
            }else if(diaQuirofano == '6'){
                dia='Sabado'
            }else if(diaQuirofano == '7'){
                dia='Domingo'
            }
            setdataHorariosQuirofanos({
                CoHSalQui:dataH.CoHSalQui,
                CoHEntQui:dataH.CoHEntQui,
                dia:dia,
                idQuirofano:e.target.nQuirofano.value
            })
            //console.log('ocupado')
            
            setmodalOnErrorCirugia(true)
            quirofanoErrorHorario = 'Error'
        }else{
            setdataHorariosQuirofanos({
                CoHSalQui:'',
                CoHEntQui:'',
                dia:'',
                idQuirofano:''
            })
            
           //console.log(setdataHorariosQuirofanos,'desocupado')
            quirofanoErrorHorario = ''
            /////aqui validamos los otros errores antes de guardar
            if(quirofanoUserError=='' && horaInicialUserError =='' && horaFinalUserError == '' && opcionUserError=='' && codigoCirujanoCargoUserError==''
            && estadoPacienteError=='' && errorFechaF=='' && errorFechaI=='' && errorDxPreoperatorio=='' && quirofanoError=='' && errorReservadoPor==''){
            setGuardadoExitosamente(true)
            //console.log(body,'si se puede guardar')
            postButtonModificarCirugia(body).then((res)=>{
                //console.log(res)


                
            }).catch((error) => {
                //console.error('Error al autenticar al usuario:', error);
                //seterrorEndpoint(true);
                
              });
            
            //validar turqui (turno quirofano)
        // const validarTurqui={
        //     EMPCOD: usuarioInfo.Empresa,
        //     MCDpto: usuarioInfo.Sede,
        //     DOCCOD:'RTQ',
        //     ProCirCod: e.target.nCirugia.value
        // }
        // postSelectTurquiValidarSiExiste(validarTurqui).then((res)=>{
        //     //console.log(res.data,'turqui')
        //     if(res.data.length === 1){
        //         //console.log('entro')
        //         const updateTurqui={
        //             TuQCns: res.data[0].TuQCns,
        //             DOCCOD: "RTQ",
        //             MCDpto: usuarioInfo.Sede,
        //             EMPCOD: usuarioInfo.Empresa,
        //             ConsCod: ProCons,
        //             TuQFchIng: `${ProFec}`,
        //             TuQFchSal: `${ProFecF}`,
        //             TuQHorIng: ProHorI,
        //             TuQHorSal: ProHorF,
        //             TuQPacId: MPCedu,
        //             TuQTipDoc: MPTDoc,
        //             TuQMedRes: ProPerSep,
        //             TuQCodCto: ProEPS,
        //             TuQNroAut: "                    "
        //         }
        //         //console.log(updateTurqui,'res.data entro')
        //         postUpdateTurqui(updateTurqui).then((res)=>{
        //             //console.log(res.data,'update turqui')
        //         })
        //     }else{
        //         postUltimoConsecutivoTurquiProgramacionCirugia().then((res)=>{
        //             //console.log(res.data,'ultimo turqui, no entro')
        //             const insertTurqui={
        //                 TuQCns: `${parseInt(res.data[0].TuQCns) + 1}`,        //Consecutivo turno quirofano
        //                 DOCCOD: "RTQ",          //Documento
        //                 MCDpto: usuarioInfo.Sede,    
        //                 EMPCOD: usuarioInfo.Empresa,
        //                 TuQFchIng: `${ProFec}`,               //Fecha Ingreso turno quirofano
        //                 TuQFchSal: `${ProFecF}`,             //Fecha Salida turno quirofano
        //                 TuQHorIng: ProHorI,                  //Hora inicial turno quirofano 
        //                 TuQHorSal: ProHorF,                  //Hora Final turno quirofano
        //                 TuQPacId: MPCedu,                   //Identificacion Paciente
        //                 TuQTipDoc: MPTDoc,                       //Tipo de Documento
        //                 TuQMedRes: ProPerSep,                     //Medico Reserva turno quirofano
        //                 TuQUsrRes: usuarioInfo.UsuarioEncriptado,                //Usuario que reserva turno quirofano 
        //                 ConsCod: ProCons,                          //Codigo Consultorio
        //                 TuQCodCto: ProEPS,                  //Codigo Contrato
        //                 TuQNroAut: "                    ",      //N�mero Autorizaci�n turno quirofano
        //                 TuQFchReg: `${fechaActual()} 00:00:00.000`,   //Fecha Registro turno quirofano
        //                 TuQEstTur: "C",                         //Estado turno quirofano
        //                 TuQObs: "",                             //Observaciones
        //                 TuQTpAnst: " ",                         //Tipo de anestesia
        //                 ProCirCod: ProCirCod,
        //                 ProEmpCod: usuarioInfo.Empresa,
        //                 ProMCDpto: usuarioInfo.Sede,
        //                 TuInsCod: "0",                          //INSTRUMENTAL QX
        //                 TuInsXML: ""                            //Instrumental XML
        //             }
        //             //console.log(insertTurqui,'turqui insert')
        //             postInsertTurqui(insertTurqui).then((res)=>{
        //                 //console.log(res.data,'res.data insert turqui')
        //             })
        //         })
        //         //console.log('no entro')
                
        //     }
        // })

        const insertQuirofanos={
            "EMPCOD":usuarioInfo.Empresa,
            "MCDpto":usuarioInfo.Sede,
            "DOCCOD":"RTQ",
            "ProCirCod":ProCirCod,
            "TuQMedRes": ProPerSep,
            "TuQUsrRes":  usuarioInfo.UsuarioEncriptado,
            "TuQNroAut": "                    ",
            "TuQEstTur": "C",
            "TuQObs": "",
            "TuQTpAnst": " ",
            "TuInsCod": "0",
            "TuInsXML": "",
            "TuQFchSal": `${ProFecF}`,
            "TuQFchIng": `${ProFec}`,
            "TuQHorIng": ProHorI,
            "TuQHorSal": ProHorF,
            "TuQCodCto": ProEPS,
            "ConsCod": ProCons
    }

        postInsertQuirofanos(insertQuirofanos).then((res)=>{
            console.log(res.data,'quirofanos insert')
        }).catch((error) => {
            console.error('Error al autenticar al usuario:', error);
            //seterrorEndpoint(true);
            
          });

        
        }else{
            //console.log(dataHorariosQuirofanos,'setdataHorariosQuirofanos No se pueden guardar los cambios')
            setmodalOnErrorCirugia(true)
        }

            ///fin de errores
        }
        })
                ///aqui terminados los horarios
               }
          })

          

        

        

    }

    
    const handleCancelClick = () => {
        setChoice(false)
        setModalOn(false)
        passDataActualizaTablaPacientes({listo:'ok'})
    }

    const cirujanoACargo = () =>{
        setModalOnCirujanoCargo(true)
    }

    const cirugiaQuirofano = () =>{
        setModalOnCirugiaQuirofano(true)
    }

    const cirugiaReservadoPor = () =>{
        setModalOnCirugiaReservadoPor(true)
    }

    const cirugiaEntidadAseguradora = () =>{
        setModalOnCirugiaEntidadAseguradora(true)
    }

    const cirugiaPalabraClave = () =>{
        setModalOnCirugiaPalabraClave(true)
    }

    const cirugiaHemoderivados = () =>{
        setModalOnCirugiaHemoderivados(true)
    }

    const cirugiaDXPreoperatorio = () =>{
        setModalOnCirugiaDXPreoperatorio(true)
    }

    const cirugiaReservadoPorEspecialidad = () =>{
        setModalOnCirugiaReservadoPorEspecialidad(true)
    }

    const cirugiaCirujanoCargoEspecialidad = () =>{
        setModalOnCirugiaCirujanoCargoEspecialidad(true)
    }

    const passDataEntidadAseguradora=(data)=>{
        //console.log(data,'ENTIDAD ASEGURADORA')
        setdataChildEntidadAseguradora(data)
    }

    const passDataPrepa = (data) =>{
        setDataChildPreoperatorio(data)
        seterrorDxPreoperatorio('')
    }
    
    const passReservado = (data) =>{              
        setdataChildReservadorPor(data)
        seterrorReservadoPor('')
    }

    const passQuiro = (data) =>{
        //console.log(data,"quirofano data")
        if(data.codigoQuirofano != '999'){
            setQuirofanoUserError('')
        }
        setDataChildQuirofano(data)
    }

    const passCirujanoACar = (data)=>{
        setDataChildCirujanoACargo(data)
        if(data.codigoMedicoEs){
            setCodigoCirujanoCargoUserError('')
        }
    }

    const passReservadoPorEspecialidad = (data) =>{
        
        setDataChildReservadoPorEspecialidad(data)
        setdataChildReservadorPor({            
            codigoMedicoEs:dataChildReservadorPor.codigoMedicoEs,
            nombreMedicoEs:dataChildReservadorPor.nombreMedicoEs,
            codigoEspecialidad:data.codigoEspecialidad,
            nombreEspecialidad:data.descripcionEspecialidad
        })
    }

    const passCirujanoACargoEspecialidad = (data) =>{
        
        setDataChildCirujanoCargoEspecialidad(data)
        setDataChildCirujanoACargo({
            codigoMedicoEs:dataChildCirujanoACargo.codigoMedicoEs,
            nombreMedicoEs:dataChildCirujanoACargo.nombreMedicoEs,
            codigoEspecialidad:data.codigoEspecialidad,
            nombreEspecialidad:data.descripcionEspecialidad
        })
    }

    

    const modificarUser = async () =>{

        //console.log(user,'USERRRRRRRRRRRRRRRRRRRR')
        //console.log(user.cirujanosProcedimiento.length,'   fechaactual')
        //setMedicos(user.cirujanosProcedimiento)

        //identificar el idCirujano mayor
        if(user.cirujanosProcedimiento.length > 0){
            const maxIdCirujano = user.cirujanosProcedimiento.reduce((max, cirujano) => {
                // Convertimos el idCirujano de string a entero
                const idCirujanoInt = parseInt(cirujano.idCirujano, 10);
                return (idCirujanoInt > max) ? idCirujanoInt : max;
              }, -Infinity);
            setNextId(maxIdCirujano + 1)
        }
        

        const body = {
            
            varProCirCod: user.ProCirCod,
            varProEmpCod: user.ProEmpCod,
            varProMCDpto: user.ProMCDpto
        }
        postCirugiaModificar(body).then((response)=>{
            //console.log(response.data, "la data para modificar")

            //Estado User
            if(response.data[0].ProEsta === "6"){
                setdataEstados('Pendiente')
            }else if(response.data[0].ProEsta === "3"){
                setdataEstados('Cancelado')
            }else if(response.data[0].ProEsta === "4"){
                setdataEstados('Realizado')
            }else if(response.data[0].ProEsta === "5"){
                setdataEstados('Facturado')
            }else if(user.ultimoEstado === 'reservado'){
                setdataEstados('reservado')
            }else if(user.ultimoEstado === 'confirmado'){
                setdataEstados('confirmado')
            }else if(user.ultimoEstado === 'ingreso a sala'){
                setdataEstados('ingreso a sala')
            }else if(user.ultimoEstado === 'preparado'){
                setdataEstados('preparado')
            }else if(user.ultimoEstado === 'cirugia'){
                setdataEstados('cirugia')
            }else if(user.ultimoEstado === 'recuperacion'){
                setdataEstados('recuperacion')
            }else if(user.ultimoEstado === 'salida'){
                setdataEstados('salida')
            }else if(response.data[0].ProEsta === "1"){
                setdataEstados('Reservado')
            }else if(response.data[0].ProEsta === "7"){
                setdataEstados('Reservado')
            }else if(response.data[0].ProEsta === "2"){
                setdataEstados('confirmado')
            }else if(response.data[0].ProEsta === "8"){
                setdataEstados('Pendiente')
            }
            
            
            setDataUser(response.data[0])
            //calcular edad
            //let fechaFinal = response.data[0].ProFecF.split(" ")[0]
            //validar fecha si llega vacio
            let fechaFinal=''
            if (response.data && response.data[0] && response.data[0].ProFec) {
                fechaFinal = response.data[0].ProFec.split(" ")[0];
                if (fechaFinal) {
                    setFechaI(fechaFinal);
                    setfechaCirugia(fechaFinal)
                }
            }

            let fechaInicial=''
            if (response.data && response.data[0] && response.data[0].ProFecF) {
                fechaInicial = response.data[0].ProFecF.split(" ")[0];
                if (fechaInicial) {
                    setFechaF(fechaInicial);
                }
            }
            //setFechaF(fechaFinal)
            //let fechaInicial = response.data[0].ProFec.split(" ")[0]
            //setFechaI(fechaInicial)
            //setfechaCirugia(fechaInicial)
            let fechaNacimiento = response.data[0].MPFchN.split(" ")[0]
            setFechaNacimientoUser(response.data[0].MPFchN)
            let yearNacimiento = new Date(fechaNacimiento)
            let fechaActualc = new Date()
            //console.log(fechaActual,'fechaActualfechaActualfechaActual')
            let calcularEdad = fechaActualc.getFullYear() - yearNacimiento.getFullYear()
            let totalMes = (fechaActualc.getMonth() + 1) - (yearNacimiento.getMonth() + 1)
            let totalDias = fechaActualc.getDate() - (yearNacimiento.getDate() + 1)

            if(totalMes >= 0 && totalDias >= 0){
                setEdadPaciente(calcularEdad)
            }else if(totalMes >= 0){
                setEdadPaciente(calcularEdad)
            }else {
                setEdadPaciente(calcularEdad - 1)
            }
            
            //Reserva de cama
            let rCama = response.data[0].ProResCam            
            if(rCama === 'S'){                
                setReservaCama(true)
            }else if(rCama === 'N'){
                setReservaCama(false)
            }

            //Req Valoración Preanestésica?
            let rVPreanestesica = response.data[0].ProRValAn            
            if(rVPreanestesica == 'S'){                                
                setReqValoracionPreanestesica(true)
            }else if(rVPreanestesica == 'N'){                 
                setReqValoracionPreanestesica(false)
            }

            //Req. Materiales Especiales?
            let rMEspeciales = response.data[0].ProReMaE            
            if(rMEspeciales === 'S'){                
                setReqMaterialesEspeciales(true)
            }else if(rMEspeciales === 'N'){
                setReqMaterialesEspeciales(false)
            }

            //Pequeña Cirugía
            if(response.data[0].PequenaCirugia){
                setDataPequenaCirugia(response.data[0].PequenaCirugia)
            }

            //Req. Materiales Especiales? textArea
            setReqDispEquiposEspecialesTextArea(response.data[0].ProObMaE)

            //Req. Disp. Equipos Especiales?
            let rDEEspeciales = response.data[0].ProDispEE            
            if(rDEEspeciales === 'S'){                
                setReqDispEquiposEspeciales(true)
            }else if(rDEEspeciales === 'N'){
                setReqDispEquiposEspeciales(false)
            }
            //textArea Req. Disp. Equipos Especiales?
            setreqDispEquiposEspecialesUserTextArea(response.data[0].ProObsEE)

            //Hemoderivados
            let hemoderi = response.data[0].ProReqHD            
            if(hemoderi === 'S'){                
                setHemoderivadosChe(true)
            }else if(hemoderi === 'N'){
                setHemoderivadosChe(false)
            }

            //data DX Preoperatorio
            setDataChildPreoperatorio({
                DMCodi: response.data[0].ProDxppal,
                DMNomb: response.data[0].ProDN1,
                PClCod: ''
            })

            //RESERVADO POR 
            setdataChildReservadorPor({
                codigoMedicoEs: (response.data[0] && response.data[0].ProPerSep) ? response.data[0].ProPerSep : '',
                nombreMedicoEs: (response.data[0] && response.data[0].NombreCirujanoReserva) ? response.data[0].NombreCirujanoReserva: '',
                codigoEspecialidad: (response.data[0] && response.data[0].ProEspSep) ? response.data[0].ProEspSep : '',
                nombreEspecialidad: (response.data[0] && response.data[0].EspecialidadReserva) ? response.data[0].EspecialidadReserva: '',
            });
            const cirujanoReservado = response.data[0].ProPerSep;
            const errorMessageReservado = !cirujanoReservado || cirujanoReservado.trim() === '' ? 'Seleccionar un Cirujano' : '';
            seterrorReservadoPor(errorMessageReservado);

            
           
           
            //CIRUJANO A CARGO
            setDataChildCirujanoACargo({
                codigoMedicoEs: (response.data[0] && response.data[0].ProPerSe1) ? response.data[0].ProPerSe1 : '',
                nombreMedicoEs: (response.data[0] && response.data[0].NombreCirujanoACargo) ? response.data[0].NombreCirujanoACargo : '',
                codigoEspecialidad: (response.data[0] && response.data[0].ProEspSe1) ? response.data[0].ProEspSe1 : '',
                nombreEspecialidad: (response.data[0] && response.data[0].EspecialidadCirujanoACargo) ? response.data[0].EspecialidadCirujanoACargo : '',
            });
            const cirujano = response.data[0].ProPerSe1;
            const errorMessage = !cirujano || cirujano.trim() === '' ? 'Seleccionar un Cirujano a Cargo' : '';
            setCodigoCirujanoCargoUserError(errorMessage);

            //CIRUJANO A CARGO DOS
            setdataOtroCirujanoCargo({
                codigoMedicoEs:(response.data[0] && response.data[0].ProPerSe2) ? response.data[0].ProPerSe2 : '',
                nombreMedicoEs:(response.data[0] && response.data[0].NombreCirujanoACargoDos) ? response.data[0].NombreCirujanoACargoDos : '',
                codigoEspecialidad:(response.data[0] && response.data[0].ProEspSe2) ? response.data[0].ProEspSe2 : '',
                nombreEspecialidad:(response.data[0] && response.data[0].EspecialidadCirujanoACargoDos) ? response.data[0].EspecialidadCirujanoACargoDos : '',
            })
            if(response.data[0] && response.data[0].ProPerSe2){
                setnuevoCiruganoACargo(true)
            }
            

            //data quirofano
            setDataChildQuirofano({
                codigoQuirofano:response.data[0].ProCons,
                descripcionQuirofano: response.data[0].ProNcons,
                sedeQuirofano:response.data[0].ProSedQr
            })

           

            //Dieta
            //setTextAreaDieta(response.data[0].ProOBs1) setIsCheckedNinguna ProOBs1
            if(response.data[0].ProOBs1){
                setIsCheckedNinguna(false)
                setTextAreaDieta(response.data[0].ProOBs1)
            }else if(!response.data[0].ProOBs1){
                setIsCheckedNinguna(true)
                setTextAreaDieta('')
            }

            //tipo de anestesia
            setTipoDeAnestesiaUser(response.data[0].ProTpAnst)

            //Estado del Paciente
            setEstadoDelPacienteUser(response.data[0].ProVivo)
            if(response.data[0].ProVivo=='0'){
                setEstadoPacienteError('Debe elegir el estado del paciente antes del acto quirúrgico')
            }else{
                setEstadoPacienteError('')
            }

            //Tipo de Cama CX
            setTipoCamaDxUser(response.data[0].ProTipCam)
            setTipoCamaCXTextAreaUser(response.data[0].ProObRCam)
            //console.log(response.data[0].ProObRCam,"textarea")

            //Cantidad
            setCantidadUser(response.data[0].PROCANORD)
            //Vol. mL
            setVolmL(response.data[0].PROVOLORD)

            //Observaciones
            setObservacionesUser(response.data[0].ProObsHD)

            //Obs. Quirurgicas
            setObsQuirurgicas(response.data[0].ProObsT)

            //Opción
            setOpcion(response.data[0].ProSit)
            if(response.data[0].ProSit == '0'){
                setOpcionUserError('Seleccionar una opción')
            }else{
                setOpcionUserError('')
            }

            //DX Preoperatorio modificar
            
            const diagnostico = response.data[0]?.ProDxppal ?? '';
            const errorMessageDiagnostico = diagnostico.trim() === '' ? 'Seleccionar un diagnóstico' : '';
            seterrorDxPreoperatorio(errorMessageDiagnostico);


            //Lateralidad
            setLateralidadUser(response.data[0].ProLat)

            //duracion
            setcalcularDuracionHora(response.data[0].ProDurHr)
            setCalcularDuracionMinutos(response.data[0].ProDurMn)
            
            

            //Entidad Aseguradora
            setdataChildEntidadAseguradora({
                MENNIT:response.data[0].ProEPS,
                MENOMB:response.data[0].ProNEPS
            })

            //Hora Inicial 
            
            // Define una cadena que representa la hora por defecto
            const defaultTime = '00:00';

            // Define una expresión regular que representa el formato de hora esperado (HH:MM)
            const timeFormat = /\d{2}:\d{2}/;

            // Obtén la hora de inicio y de fin sin procesar de los datos de respuesta
            const startTimeRaw = response.data[0].ProHorI;
            const endTimeRaw = response.data[0].ProHorF;

            // Establece los valores por defecto para la hora de inicio y fin
            let startTime = defaultTime;
            let endTime = defaultTime;

            // Si la hora de inicio sin procesar cumple con el formato de hora, divídela y úsala
            if (timeFormat.test(startTimeRaw)) {
                let splitTime = startTimeRaw.split(':');
                startTime = `${splitTime[0]}:${splitTime[1]}`;
                //console.log(startTime,'HORA INICIO')
                //validar hora actual
                const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
                let fechaA= fechaActual()
                if((startTime < currentLocalTime) && (fechaInicial === fechaA)){ 
                    setHoraInicialUserError('Hora Inicial no puede ser menor a la Hora Actual')
                }
            }

            // Si la hora de fin sin procesar cumple con el formato de hora, divídela y úsala
            if (timeFormat.test(endTimeRaw)) {
                let splitTime = endTimeRaw.split(':');
                endTime = `${splitTime[0]}:${splitTime[1]}`;
                //console.log(endTime,'FINAL HORA')
                //validar hora actual
                const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
                let fechaA= fechaActual()
                if((endTime < currentLocalTime) && (fechaFinal === fechaA)){
                    setHoraFinalUserError('Hora Final no puede ser menor a la Hora Actual')
                }
            }

            // Actualiza la hora de inicio y fin en el estado de la aplicación
            setHoraI(startTime);
            setHoraF(endTime);

            // Si la hora de inicio y fin son iguales, asigna los mensajes de error correspondientes
            if(startTime === endTime){
                setHoraInicialUserError('Hora Inicial y Hora Final son Iguales')
                setHoraFinalUserError('Hora Inicial y Hora Final son Iguales')
            }

            

            //Quirofano ProSedQr VERIFICAR
            if(response.data[0].ProCons == '999'){
                setQuirofanoUserError('Seleccionar un Quirófano')
            }else if(!response.data[0].ProCons){
                setQuirofanoUserError('Seleccionar un Quirófano')
            }else if(response.data[0].ProCons != '999'){
                setQuirofanoUserError('')
            }  


            ///////////VARIABLES NO USADAS
            setHCFcHrOrdUser(response.data[0].HCFcHrOrd)
            setHCPrctpopUser(response.data[0].HCPrctpop)
            setINSCODIUser(response.data[0].INSCODI)
            setIdCirugiasUser(response.data[0].IdCirugias)
            setMPCeduUser(response.data[0].MPCedu)
            setMPSexoUser(response.data[0].MPSexo)
            setPNmPrCnfUser(response.data[0].PNmPrCnf)
            setPPersCnfUser(response.data[0].PPersCnf)
            setPROCODHEMUser(response.data[0].PROCODHEM)
            setPROHEMCIRUser(response.data[0].PROHEMCIR)
            setPROINSCIRUser(response.data[0].PROINSCIR)
            setPUsrConfUser(response.data[0].PUsrConf)
            setPfcHrCnfUser(response.data[0].PfcHrCnf)
            setProCEmpUser(response.data[0].ProCEmp)
            setProCSedeUser(response.data[0].ProCSede)
            setProCitEstUser(response.data[0].ProCitEst)
            setProCitNumUser(response.data[0].ProCitNum)
            setProCodHDUser(response.data[0].ProCodHD)
            setProEstaUser(response.data[0].ProEsta)
            setProFSepUser(response.data[0].ProFSep)
            setProFecSRUser(response.data[0].ProFecSR)
            setProFliCxUser(response.data[0].ProFliCx)
            setProFliSolUser(response.data[0].ProFliSol)
            setProHSepUser(response.data[0].ProHSep)
            setProMtCnTpUser(response.data[0].ProMtCnTp)
            setProNomsepUser(response.data[0].ProNomsep)
            setProRegOpeUser(response.data[0].ProRegOpe)
            setProUserUser(response.data[0].ProUser)
            setProViaUSer(response.data[0].ProVia)
        }).catch(error => {
            console.error('Error al autenticar al usuario:', error);
            // seterrorEndpoint(true)
            setloading(true)
          });
    }
    useEffect(()=>{
        setloading(false)
        modificarUser()
        setTimeout(() => {          
            setloading(true)
          }, 2500);

          getObtenerTodasOpcionesCirugia().then((res)=>{
            //console.log(res.data.data,'opcion')
            setdataOpcionCirugia(res.data.data)
          })
          console.log(fechaActual(),' fechaActual')

    //       let fecha = new Date()
    // let year = fecha.getFullYear()
    // let mes = `${fecha.getMonth() + 1}`
    // let dia = `${fecha.getDate()}`    
    // if(mes.length == '1'){
    //     mes = `0${fecha.getMonth() + 1}`
    // }else{
    //     mes = `${fecha.getMonth() + 1}`
    // }
    
    // if(dia.length == '1'){
    //     dia = `0${fecha.getDate()}`
    // }else{
    //     dia = `${fecha.getDate()}`
    // }
    // let fechaCompleta = `${year}-${mes}-${dia}`
    // setFechaInicio(fechaCompleta)
    // setFechaFinal(fechaCompleta)
    // setFechaActual(fechaCompleta)
    },[]);

    // const onSubmit = data => setDataUser(data);
    // console.log(dataUser,"cole");
    

  const handleOnChangeNinguna = () => {
    setIsCheckedNinguna(!isCheckedNinguna);
    if(!isCheckedNinguna){
        setTextAreaDieta('')
        setBlanda(false)
        setLiquida(false)
        setCorriente(false)
        setHiposodica(false)
        setAyuno(false)
        setEnemaEvacuador(false)
        setPremedicacion(false)
        setAcompanante(false)
        setRasurada(false)
        setSeisHorasAntes(false)
        setOchoHorasAntes(false)
        setDoceHorasAntes(false)
        setVeinteCuatroHorasAntes(false)
        ///
        setvalidacionesDisabledHoraOcho(false)
        setvalidacionesDisabledHoraDoce(false)
        setvalidacionesDisabledHoraVeintiCuatro(false)
        setvalidacionesDisabledHoraSeis(false)
    }
    //if(reqValoracionPreanestesica)
  };
  /////////////////ONCHANGE///////////////
  //Dieta
  const handleOnchangeDieta = () =>{
    setIsCheckedNinguna(false)
    setBlanda(!blanda)   
    let dietablanda = textAreaDieta + '- DIETA BLANDA'
    setTextAreaDieta(dietablanda)    
  }

  const handleOnchangeDietaLiquida = () =>{
    setLiquida(!liquida)
    setIsCheckedNinguna(false)
    let dietaliquida = textAreaDieta + '- DIETA LIQUIDA'
    setTextAreaDieta(dietaliquida) 
  }

  const handleOnchangeDietaCorriente = () =>{
    setCorriente(!corriente)
    setIsCheckedNinguna(false)
    let dietacorriente = textAreaDieta + '- DIETA CORRIENTE'
    setTextAreaDieta(dietacorriente)
  }

  const handleOnchangeDietaHiposodica = () =>{
    setHiposodica(!hiposodica)
    setIsCheckedNinguna(false)
    let dietahiposodica = textAreaDieta + '- DIETA HIPOSÓDICA'
    setTextAreaDieta(dietahiposodica)
  }

  const handleOnchangeDietaAyuno = () =>{
    setAyuno(!ayuno)
    setIsCheckedNinguna(false)
    let dietaayuno = textAreaDieta + '- DIETA AYUNO'
    setTextAreaDieta(dietaayuno)
  }

  const handleOnchangeDietaEnema = () =>{
    setEnemaEvacuador(!enemaEvacuador)
    setIsCheckedNinguna(false)
    let dietaenema = textAreaDieta + '- DIETA ENEMA EVACUADOR'
    setTextAreaDieta(dietaenema)
  }

  const handleOnchangePremedicacion = () =>{
    setPremedicacion(!premedicacion)
    setIsCheckedNinguna(false)
    let dietapremedicacion = textAreaDieta + '- PREMEDICACIÓN'
    setTextAreaDieta(dietapremedicacion)
  }

  const handleOnchangeAcompanante = () =>{
    setAcompanante(!acompanante)
    setIsCheckedNinguna(false)
    let dietaacompanante = textAreaDieta + '- ACOMPAÑANTE'
    setTextAreaDieta(dietaacompanante)
  }

  const handleOnchangeRasurada = () =>{
    setRasurada(!rasurada)
    setIsCheckedNinguna(false)
    let dietarasurada = textAreaDieta + '- RASURADA'
    setTextAreaDieta(dietarasurada)
  }

  const handleOnchangeSeisHorasAntes = () =>{
    setSeisHorasAntes(!seisHorasAntes)
    setIsCheckedNinguna(false)
    
    if(!seisHorasAntes){
        let seis = textAreaDieta + '- 6 HORAS ANTES DE LA CIRUGÍA'
        setTextAreaDieta(seis)
        setvalidacionesDisabledHoraOcho(true)
        setvalidacionesDisabledHoraDoce(true)
        setvalidacionesDisabledHoraVeintiCuatro(true)
    }else{
        setvalidacionesDisabledHoraOcho(false)
        setvalidacionesDisabledHoraDoce(false)
        setvalidacionesDisabledHoraVeintiCuatro(false)
    }
  }

  const handleOnchangeOchoHorasAntes = () =>{
    setOchoHorasAntes(!ochoHorasAntes)
    setIsCheckedNinguna(false)
    if(!ochoHorasAntes){
        let ocho = textAreaDieta + '- 8 HORAS ANTES DE LA CIRUGÍA'
        setTextAreaDieta(ocho)
        setvalidacionesDisabledHoraSeis(true)
        setvalidacionesDisabledHoraDoce(true)
        setvalidacionesDisabledHoraVeintiCuatro(true)
    }else{
        setvalidacionesDisabledHoraSeis(false)
        setvalidacionesDisabledHoraDoce(false)
        setvalidacionesDisabledHoraVeintiCuatro(false)
    }
  }

  const handleOnchangeDoceHorasAntes = () =>{
    setDoceHorasAntes(!doceHorasAntes)
    setIsCheckedNinguna(false)
    if(!doceHorasAntes){
        let doce = textAreaDieta + '- 12 HORAS ANTES DE LA CIRUGÍA'
        setTextAreaDieta(doce)
        setvalidacionesDisabledHoraSeis(true)
        setvalidacionesDisabledHoraOcho(true)
        setvalidacionesDisabledHoraVeintiCuatro(true)
    }else{
        setvalidacionesDisabledHoraSeis(false)
        setvalidacionesDisabledHoraOcho(false)
        setvalidacionesDisabledHoraVeintiCuatro(false)
    }
  }

  const handleOnchangeVeintiCuatroHorasAntes = () =>{
    setVeinteCuatroHorasAntes(!veinteCuatroHorasAntes)
    setIsCheckedNinguna(false)
    if(!veinteCuatroHorasAntes){
        let veinte = textAreaDieta + '- 24 HORAS ANTES DE LA CIRUGÍA'
        setTextAreaDieta(veinte)
        setvalidacionesDisabledHoraSeis(true)
        setvalidacionesDisabledHoraOcho(true)
        setvalidacionesDisabledHoraDoce(true)
    }else{
        setvalidacionesDisabledHoraSeis(false)
        setvalidacionesDisabledHoraOcho(false)
        setvalidacionesDisabledHoraDoce(false)
    }
  }

  //Opcion
  const handleOnchangeOpcion = (e)=>{
    setOpcion(e.target.value)
    if(e.target.value == '0'){
        setOpcionUserError('Seleccionar una Opción')
    }else if(e.target.value !== '0'){
        setOpcionUserError('')
    }
  }

  //Req Valoración Preanestésica?
  const handleOnchangeReqValoracionPreanestesica = () =>{
    setReqValoracionPreanestesica(!reqValoracionPreanestesica)    
  }

  const handleOnChangePequenaCirugia = (e) =>{
    console.log(e.target.checked ? "S" : "N",' pequena cirugia')
    setDataPequenaCirugia(e.target.checked ? "S" : "N");
}

  //Tipo de Anestesia
  const handleOnchangeTipoDeAnestesia = (e) =>{
    setTipoDeAnestesiaUser(e.target.value)
    //console.log(e.target.value,'tipoDeAnestesiaUser')
  }

  //Estado del Paciente
  const handleOnchangeEstadoDelPaciente = (e) =>{
    setEstadoDelPacienteUser(e.target.value)
    if(e.target.value == "0"){
        setEstadoPacienteError('Debe elegir el estado del paciente antes del acto quirúrgico')
    }else if(e.target.value != "0"){
        setEstadoPacienteError('')
    }
  }

  //Reserva de cama?
  const handleOnchangeReservaDeCama = () =>{
    setReservaCama(!reservaCama)
  }

  //Tipo de Cama CX
  const handleOnchangeTipoDeCamaCX = (e) =>{
    setTipoCamaDxUser(e.target.value)
  }
  const handleOnchangeTextAreaTipoDeCamaCx =(e)=>{
    setTipoCamaCXTextAreaUser(e.target.value)
    //console.log(e.target.value, "handleOnchangeTextAreaTipoDeCamaCx")
  }

  //Req. Materiales Especiales?
  const handleOnchangeReqMateEspeciales = ()=>{
    setReqMaterialesEspeciales(!reqMaterialesEspeciales)
  }

  //Req. Materiales Especiales? textArea
  const handleOnchangeReqMaterialesEspecialesTextArea = (e)=>{
    setReqDispEquiposEspecialesTextArea(e.target.value)
  }

  //Req. Disp. Equipos Especiales?
  const handleOnchangeReqDispEquiposEspeciales = () =>{
    setReqDispEquiposEspeciales(!reqDispEquiposEspeciales)
  }

  //Req. Disp. Equipos Especiales? textArea
  const handleOnchangeReqDispEquiposEspcialesUser = (e)=>{
    setreqDispEquiposEspecialesUserTextArea(e.target.value)
  }

  //Hemoderivados
  const handleOnchangeHemoderivados = ()=>{
    setHemoderivadosChe(!hemoderivadosChe)
  }

  //Cantidad
  const handleOnchangeCantidad =(e)=>{
    setCantidadUser(e.target.value)
  }

  //Vol. mL
  const handleOnchangeVolmL =(e)=>{
    setVolmL(e.target.value)
  }

  //Observaciones
  const handleOnchangeObservaciones=(e)=>{
    setObservacionesUser(e.target.value)
  }

  //Obs. Quirurgicas
  const handleOnchangeObsQuirurgicas=(e)=>{
    setObsQuirurgicas(e.target.value)
  }

  //textArea Dieta
  const handleOnchangeDietaTextArea =(e)=>{
    setTextAreaDieta(e.target.value)
  }

  //Lateralidad
  const handleOnchangeLateralidad = (e)=>{
    setLateralidadUser(e.target.value)
  }

  //hora inicial
  const handleOnchangeHoraInicial = (e) =>{
    setHoraI(e.target.value)
    
    let horasMinutos = e.target.value
    let splitHorasMinutos = horasMinutos.split(':')
    let calcularMinutosInicial = (parseInt(splitHorasMinutos[0]) * 60) + parseInt(splitHorasMinutos[1])
    //Hora final
    let splithorasMinutosFinal = horaF.split(':')
    let calcularMinutosFinal = (parseInt(splithorasMinutosFinal[0]) * 60) + parseInt(splithorasMinutosFinal[1])

    //duracionHora
    let startDate = new Date(`${fechaCirugia} ${e.target.value}`)
    let endDate = new Date(`${fechaCirugia} ${horaF}`)
    let difference = endDate.getTime() - startDate.getTime();

    //validar hora actual
    const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });

    console.log(currentLocalTime,'hora actual')
    console.log(horasMinutos,'hora ingresada')

    
    if(difference < 0){
        setcalcularDuracionHora('0')
        setCalcularDuracionMinutos('0')
    }else{
        difference = difference / 1000;
        let hourDifference = Math.floor(difference / 3600);
        setcalcularDuracionHora(hourDifference)
        difference -= hourDifference * 3600;
        let minuteDifference = Math.floor(difference / 60);
        setCalcularDuracionMinutos(minuteDifference)
    } 

    if(e.target.value == horaF){
        setHoraInicialUserError('Hora Inicial y Hora Final son Iguales')
        setHoraFinalUserError('Hora Inicial y Hora Final son Iguales')
        
    }else if(calcularMinutosInicial > calcularMinutosFinal){
        setHoraInicialUserError('Hora Inicial no puede ser mayor a la Hora Final')
        setHoraFinalUserError('')
        
    }else if((horasMinutos < currentLocalTime) && (fechaActual() ===  fechaI) ){
        setHoraInicialUserError('Hora Inicial no puede ser menor a la Hora Actual')
        setHoraFinalUserError('')
    }else if((horaF < currentLocalTime)&& (fechaActual() ===  fechaF)){
        setHoraInicialUserError('')
        setHoraFinalUserError('Hora Final no puede ser menor a la Hora Actual')
    }else{
        setHoraInicialUserError('')
        setHoraFinalUserError('')
        
    }
    
  }
  //Hora Final
  const handleOnchangeHoraFinal = (e)=>{
    setHoraF(e.target.value)
    
    //hora final
    let horasMinutos = e.target.value
    let splitHorasMinutos = horasMinutos.split(':')
    let horas = parseInt(splitHorasMinutos[0])
    let minutos = parseInt(splitHorasMinutos[1])
    let pasarHorasAMinutos = horas * 60
    let totalMinutosFinal = pasarHorasAMinutos + minutos
    //console.log(totalMinutosFinal,'totalMinutosFinal')
    //hora inicial
    let horasMinutosInicial = horaI.split(':')
    let horasInicial = parseInt(horasMinutosInicial[0])
    let minutosInicial = parseInt(horasMinutosInicial[1])
    let totalMinutosInicial = (horasInicial * 60) + minutosInicial
    //console.log(totalMinutosInicial,'totalMinutosInicial')

    //duracionHora
    let startDate = new Date(`${fechaCirugia} ${horaI}`)
    let endDate = new Date(`${fechaCirugia} ${e.target.value}`)
    let difference = endDate.getTime() - startDate.getTime();

    //validar hora actual
    const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });

    if(difference < 0){
        setcalcularDuracionHora('0')
        setCalcularDuracionMinutos('0')
    }else{
        difference = difference / 1000;
        let hourDifference = Math.floor(difference / 3600);
        setcalcularDuracionHora(hourDifference)
        difference -= hourDifference * 3600;
        let minuteDifference = Math.floor(difference / 60);
        setCalcularDuracionMinutos(minuteDifference)
    }   
    

    if(horaI == e.target.value){
        setHoraInicialUserError('Hora Inicial y Hora Final son Iguales')
        setHoraFinalUserError('Hora Inicial y Hora Final son Iguales')
        
    }else if(totalMinutosInicial > totalMinutosFinal){
        setHoraInicialUserError('')
        setHoraFinalUserError('Hora Final no puede ser menor a la Hora Inicial')
        
    }else if((horasMinutos < currentLocalTime) && (fechaActual() === fechaF)){
        setHoraInicialUserError('')
        setHoraFinalUserError('Hora Final no puede ser menor a la Hora Actual')
    }else if((horaI < currentLocalTime) && (fechaActual() === fechaI)){
        setHoraInicialUserError('Hora Inicial no puede ser menor a la Hora Actual')
        setHoraFinalUserError('')
    }else{
        setHoraInicialUserError('')
        setHoraFinalUserError('')
        
    }
    
  }

  //Fecha Inicial
  const handleOnchangeFechaInicial=(e)=>{
    //console.log(fechaI,'fechaI')
    setFechaI(e.target.value)
    let dateInicial = new Date(e.target.value)
    let dateFinal = new Date(fechaF)
    let restaInicialFinal = dateFinal - dateInicial
    let dateActual = new Date(fechaCirugia)
    let restActualInicio = dateInicial - dateActual

    if(restActualInicio < 0){
        setErrorFechaI('Fecha de la cirugia no puede ser menor a la fecha de separación de la misma, por favor verifique')
        setErrorFechaF('')
    }else if(restaInicialFinal < 0){
        setErrorFechaI('Fecha Inicial no puede ser mayor a la fecha Final')
        setErrorFechaF('')
    }else if(restaInicialFinal != 0){
        setErrorFechaI('La duración de la cirugia supera las 24 horas, verifique')
        setErrorFechaF('')
    }else if(restaInicialFinal == 0){
        setErrorFechaI('')
        setErrorFechaF('')
    }

    //validar hora
    const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });

    if(!horaF){
        setHoraInicialUserError('')
        setHoraFinalUserError('Seleccionar hora final')
    }else if(!horaI){
        setHoraInicialUserError('Seleccionar hora inicial')
        setHoraFinalUserError('')
    }
    else if((fechaActual() === fechaF) && (horaF < currentLocalTime)){
        setHoraInicialUserError("");
        setHoraFinalUserError("Hora Final no puede ser menor a la Hora Actual");
      }else if((horaI < currentLocalTime) && (fechaActual() === e.target.value)){
        setHoraInicialUserError("Hora Inicial no puede ser menor a la Hora Actual");
        setHoraFinalUserError("");
      }
      else if(horaI === horaF){
        setHoraInicialUserError("Hora Inicial no puede ser igual a la Hora Final")
        setHoraFinalUserError("Hora Final no puede ser igual a la Hora Inicial")
      }else if(horaI > horaF){
        setHoraInicialUserError("Hora Inicial no puede ser mayor a la Hora Final")
        setHoraFinalUserError("")
      }else if(verificarHoras(horaI,horaF)){
        setHoraInicialUserError("Hora Inicial no puede ser mayor a la Hora Final")
        setHoraFinalUserError("")
      }else{
        setHoraInicialUserError("")
        setHoraFinalUserError("")
      }
  }

  //Fecha Final
  const handleOnchangeFechaFinal=(e)=>{
    setFechaF(e.target.value)
    let dateInicial = new Date(fechaI)
    let dateFinal = new Date(e.target.value)
    let restaInicialFinal = dateFinal - dateInicial
    let dateActual = new Date(fechaCirugia)
    let restActualInicio = dateFinal - dateActual
    if(restActualInicio < 0){
        setErrorFechaI('')
        setErrorFechaF('Fecha de la cirugia no puede ser menor a la fecha de separación de la misma, por favor verifique')
    }else if(restaInicialFinal < 0){
        setErrorFechaI('')
        setErrorFechaF('Fecha Final no puede ser menor a la fecha Inicial')
    }else if(restaInicialFinal != 0){
        setErrorFechaF('La duración de la cirugia supera las 24 horas, verifique')
        setErrorFechaI('')
    }else if(restaInicialFinal == 0){
        setErrorFechaI('')
        setErrorFechaF('')
    }

    //validar hora
    const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
    if(!horaF){
        setHoraInicialUserError("Seleccionar hora final")
      setHoraFinalUserError("")
    }else if(!horaI){
        setHoraInicialUserError("Seleccionar hora inicial")
      setHoraFinalUserError("")
    }
    else if((fechaActual() === e.target.value) && (horaF < currentLocalTime)){
        setHoraInicialUserError("");
      setHoraFinalUserError("Hora Final no puede ser menor a la Hora Actual");
    }else if((horaI < currentLocalTime) && (fechaActual() === fechaI)){
        setHoraInicialUserError("Hora Inicial no puede ser menor a la Hora Actual");
      setHoraFinalUserError("");
    }
    else if(horaI === horaF){
        setHoraInicialUserError("Hora Inicial no puede ser igual a la Hora Final")
        setHoraFinalUserError("Hora Final no puede ser igual a la Hora Inicial")
    }else if(verificarHoras(horaI,horaF)){
        setHoraInicialUserError("Hora Inicial no puede ser mayor a la Hora Final")
      setHoraFinalUserError("")
    } 
    else{
        setHoraInicialUserError("");
      setHoraFinalUserError("");
    }
  }

  function verificarHoras(horaInici, horaFina) {
    // Crear objetos Date a partir de las horas proporcionadas
    const [horaInicio, minutoInicio] = horaInici.split(':').map(Number);
    const [horaFin, minutoFin] = horaFina.split(':').map(Number);

    const inicio = new Date();
    inicio.setHours(horaInicio, minutoInicio, 0, 0);

    const fin = new Date();
    fin.setHours(horaFin, minutoFin, 0, 0);

    // Verificar si la hora inicial es mayor que la hora final
    if (inicio > fin) {
        return true;
    } else {
        return false;
    }
}

  //N° Quirófano
  
    
  return (
    <>
    
        <div className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable" tabIndex="-1" aria-labelledby="exampleModalScrollableLabel" aria-hidden="true">
    <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
        {/* {loading?
        <>
        <div className="flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
      <h5
        className="text-xl font-medium leading-normal text-white"
        id="exampleModalScrollableLabel"
      >
        Modificar Cirugía
      </h5>
      <button
        type="button"
        onClick={handleCancelClick}
        className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        X
      </button>
    </div>
    <div className="text-center py-48"><Loading/></div>
    </>
    :
    (
    <> */}
        <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#437cdc]">
            
            <ul
            className="flex mb-0 list-none flex-wrap pt-3 pb-2 flex-row"
            role="tablist"
          >
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-3 py-2 shadow-lg rounded block leading-normal " +
                  (openTab === 1
                    ? "text-white bg-" + color + "-600"
                    : "text-" + color + "-600 bg-white")
                }
                onClick={e => {
                  e.preventDefault();
                  setOpenTab(1);
                }}
                data-toggle="tab"
                href="#link1"
                role="tablist"
              >
                Cirugía
              </a>
            </li>
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-3 py-2 shadow-lg rounded block leading-normal " +
                  (openTab === 2
                    ? "text-white bg-" + color + "-600"
                    : "text-" + color + "-600 bg-white")
                }
                onClick={e => {
                  e.preventDefault();
                  setOpenTab(2);
                }}
                data-toggle="tab"
                href="#link2"
                role="tablist"
              >
                 Procedimiento
              </a>
            </li>
            
          </ul>
            <button type="button"
            onClick={handleCancelClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal" aria-label="Close">X</button>
        </div>
        <div className="flex-auto overflow-y-auto relative p-2">
        <form onSubmit={handleModificar} className={openTab === 1 ? "block" : "hidden"} id="link1">
        <div className="flex-auto overflow-y-auto relative ">
            
            <div className="flex flex-row   text-left">
                                <div className="w-1/5  px-1 ">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium " >
                                        Empresa
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        defaultValue={dataUser.ProEmpCod?dataUser.ProEmpCod:null}
                                        //autoComplete='off'
                                        name="empresa"
                                        //value={empresaModificar}
                                        //onChange={empresaInput}
                                        disabled={true}
                                        // {...register('ProEmpCod')}
                                        type="text"
                                        className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Sede
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        defaultValue={dataUser.ProMCDpto? dataUser.ProMCDpto:null}
                                        disabled={true}
                                        // {...register('ProCSede')}
                                        type="text"
                                        name = 'sede'
                                        className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        N° Cirugía
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        defaultValue={dataUser.ProCirCod?dataUser.ProCirCod:null}
                                        disabled={true}
                                        type="text"
                                        name = 'nCirugia'
                                        className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        N° Autorización
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        defaultValue={dataUser.ProCirAut?dataUser.ProCirAut:null}
                                        type="text"
                                        name = 'nAutorizacion'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Estado
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={props.userDate.ProEmpCod}
                                        defaultValue={dataEstados}
                                        disabled={true}
                                        type="text"
                                        name = 'estadoPaciente'
                                        className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
            </div>
            
            <div className="flex py-2 text-left">
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    N° Quirófano 
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        onFocus={cirugiaQuirofano}
                                        //defaultValue={dataUser.ProCons}
                                        defaultValue={dataChildQuirofano.codigoQuirofano?dataChildQuirofano.codigoQuirofano:null}
                                        name = 'nQuirofano'
                                        //onChange={(e) => console.log(e.target.nQuirofano.value)}
                                        type="text"
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                        readOnly
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {quirofanoUserError}
                                    </label>
                                </div>
                                <div className="w-2/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    Quirófano
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProNcons}
                                        defaultValue={dataChildQuirofano.descripcionQuirofano?dataChildQuirofano.descripcionQuirofano:null}
                                        disabled={true}
                                        type="text"
                                        name='nombreQuirofano'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Sede Quirófano
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={props.userDate.ProEmpCod}
                                        //defaultValue={dataUser.ProSedQr}
                                        defaultValue={dataChildQuirofano.sedeQuirofano}
                                        disabled={true}
                                        type="text"
                                        name = 'sedeQuirofano'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Indi. Oportunidad
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={props.userDate.ProEmpCod} 
                                        defaultValue={dataUser.ProIndOpu}
                                        type="number"
                                        name = 'indOportunidad'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
            </div>
            
            <div className="flex  text-left">
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Fecha Inicial
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        value={fechaI}
                                        //disabled={true}
                                        onChange={handleOnchangeFechaInicial}
                                        //defaultValue={dataUser.ProFec? dataUser.ProFec.split()}
                                        type="date"
                                        name = 'fechaInicial'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {errorFechaI}
                                    </label>
                                    
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    Hora Inicial
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProHorI}
                                        value={horaI}
                                        onChange={handleOnchangeHoraInicial}
                                        type="time"
                                        name = 'horaInicial'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {horaInicialUserError}
                                    </label>
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Fecha Final
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={fechaActual()}
                                        value={fechaF}
                                        onChange={handleOnchangeFechaFinal}
                                        type="date"
                                        name='fechaFinal'
                                        //disabled={true}
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {errorFechaF}
                                    </label>
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Hora Final
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProHorF}
                                        value={horaF}
                                        onChange={handleOnchangeHoraFinal}
                                        type="time"
                                        name = 'horaFinal'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {horaFinalUserError}
                                    </label>
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Duración
                                    </label>
                                    <div className="flex">
                                        <input
                                            
                                            //defaultValue={dataUser.ProDurHr}
                                            defaultValue={calcularDuracionHora}
                                            disabled={true}
                                            type="number"
                                            name = 'horaDuracion'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder="HH"
                                        />
                                        <label className="pt-1 px-2">:</label>
                                        <input
                                            
                                            //defaultValue={dataUser.ProDurMn}
                                            defaultValue={calcularDurarionMinutos}
                                            disabled={true}
                                            type="number"
                                            name='minutoDuracion'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder="MM"
                                        />
                                    </div>
                                </div>
            </div>
            <div className="flex py-2 text-left">
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        N° Documento
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        defaultValue={dataUser.MPCedu}
                                        disabled={true}
                                        type="text"
                                        name='numeroDocumento'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    Tipo Documento
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        defaultValue={dataUser.MPTDoc}
                                        disabled={true}
                                        type="text"
                                        name = 'tipoDocumento'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-2/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Nombre del Paciente
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        defaultValue={dataUser.MPNOMC}
                                        disabled={true}
                                        type="text"
                                        name='nombrePaciente'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Edad
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            defaultValue={edadPaciente}
                                            disabled={true}
                                            type="number"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            defaultValue={years}
                                            disabled={true}
                                            type="text"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                </div>
            </div>
            <div className="flex py-2 text-left">
                <div  className="w-1/2 py-2 text-left px-1">
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium " >
                     Opción
                </label>
                <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example " 
                //defaultValue={dataUser.ProSit}
                value={opcion}
                onChange={handleOnchangeOpcion} 
                >
                                        

                                       
                                        <option value="0">Sin seleccionar</option>
                                        {
                                          dataOpcionCirugia.map((item)=>(
                                            <option value={item.PrcMulOpc} key={item.PrcMulOpc}>{item.PrcMulDsc}</option>
                                          ))
                                        }
                                        
                                        
                                    </select>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {opcionUserError}
                                    </label>
            </div>
            <div className="w-1/2 p-10">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        PEQUEÑA CIRUGÍA?
                                    </label>
                                    <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" 
                                    type="checkbox" 
                                    name= 'pequenaCirugia'
                                    id="flexCheckDefault"
                                    checked={dataPequenaCirugia === 'S'}
                                    onChange={handleOnChangePequenaCirugia}
                                    />
                                </div>
            </div>
            
            <div className="flex py-1 text-left">
                                <div className="w-1/2  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Reservado Por
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            onFocus={cirugiaReservadoPor}
                                            //defaultValue={dataUser.ProPerSep}
                                            defaultValue={dataChildReservadorPor.codigoMedicoEs}
                                            type="text"
                                            name = 'coReservadoPor'
                                            autoComplete='off'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec]  bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            disabled={true}
                                            defaultValue={dataChildReservadorPor.nombreMedicoEs}
                                            type="text"
                                            name='nombreReservadoPor'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                            {errorReservadoPor}
                                        </label>
                                </div>
                                <div className="w-1/2  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Especialidad
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            //defaultValue={dataUser.ProEspSep}
                                            defaultValue={dataChildReservadorPor.codigoEspecialidad}
                                            onFocus={cirugiaReservadoPorEspecialidad}
                                            type="text"
                                            name = 'reservadoPorEspecialidad'
                                            autoComplete='off'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}dataChildReservadoPorEspecialidad       
                                            defaultValue={dataChildReservadorPor.nombreEspecialidad}
                                            type="text"
                                            disabled={true}
                                            name='nombreReservadoPorEspecialidad'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                </div>
                                
                                
                                
                                
            </div>
            <div className="flex py-1 text-left">
                                <div className="w-1/2  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Cirujano a Cargo
                                        {/* <button type="button"
            onClick={handleClickCiruganoCargoOtro}
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            +
            </button> */}
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            onFocus={cirujanoACargo}
                                            //defaultValue={dataUser.ProPerSe1}
                                            defaultValue={dataChildCirujanoACargo.codigoMedicoEs}
                                            autoComplete='off'
                                            type="text"
                                            name='codigoCirujanoCargo'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}dataChildCirujanoACargo.nombreMedicoEs
                                            defaultValue={dataChildCirujanoACargo.nombreMedicoEs}
                                            type="text"
                                            name='nombreCirujanoCargo'
                                            disabled={true}
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                            {codigoCirujanoCargoUserError}
                                        </label>
                                </div>
                                <div className="w-1/2  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Especialidad
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={dataUser.ProDxppal}
                                            type="text"
                                            name='codigoCirujanoCargoEspecialidad'
                                            //defaultValue={dataUser.ProEspSe1}
                                            defaultValue={dataChildCirujanoACargo.codigoEspecialidad}
                                            onFocus={cirugiaCirujanoCargoEspecialidad}
                                            autoComplete='off'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={dataUser.ProDN1}
                                            defaultValue={dataChildCirujanoACargo.nombreEspecialidad}
                                            type="text"
                                            name = 'nombreCirujanoCargoEspecialidad'
                                            disabled={true}
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                    
                                </div>
            </div>
            {/* {nuevoCiruganoACargo &&
            <div className="flex  text-left">
            <div className="w-1/2  px-1">
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                    Otro Cirujano a Cargo
                    
                </label>
                <div className="flex">
                    <input                        
                        onFocus={otroCirujanoACargo}                        
                        value={dataOtroCirujanoCargo.codigoMedicoEs}
                        autoComplete='off'
                        type="text"                        
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        readOnly
                    />
                    
                    <label className="px-2"></label>
                    <input
                        
                        value={dataOtroCirujanoCargo.nombreMedicoEs}
                        type="text"
                        
                        disabled={true}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                    />
                </div>
               
            </div>
            <div className="w-1/2  px-1">
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                    Especialidad
                </label>
                <div className="flex">
                    <input
                        
                        type="text"
                        
                        value={dataOtroCirujanoCargo.codigoEspecialidad}
                        onFocus={otraEspecialidadACargo}
                        autoComplete='off'
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        readOnly
                    />
                    <label className="px-2"></label>
                    <input
                        
                        value={dataOtroCirujanoCargo.nombreEspecialidad}
                        type="text"
                        
                        disabled={true}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                    />
                    <button type="button"
            onClick={handleClickBorrarCirujanoCargoOtro}
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Borrar
            </button>
                </div>
                
            </div>
</div>
            }
 */}


{/* {medicos.map((medico, index) => (  

<div className="flex  text-left mb-8" key={index}>
            <div className="w-1/2  px-1">
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                    Otro Cirujano a Cargo {medico.idCirujano}
                    
                </label>
                <div className="flex">
                    <input
                        
                        onFocus={()=>otroCirujanoACargo(medico.idCirujano)}
                        
                        value={medico.codigo_medico}
                        autoComplete='off'
                        type="text"
                        
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        readOnly
                    />
                    
                    <label className="px-2"></label>
                    <input
                        
                        value={medico.nombre_medico}
                        type="text"
                        
                        disabled={true}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                    />
                </div>
                
            </div>
            <div className="w-1/2  px-1">
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                    Especialidad
                </label>
                <div className="flex">
                    <input
                        
                        type="text"
                        
                        value={medico.codigo_especialidad}
                        onFocus={()=>otraEspecialidadACargo(medico.idCirujano)}
                        autoComplete='off'
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        readOnly
                    />
                    <label className="px-2"></label>
                    <input
                        
                        value={medico.nombre_especialidad}
                        type="text"
                        
                        disabled={true}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                    />
                     
                    <button type="button"
            onClick={() => handleRemoveFields(medico.idCirujano)}
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Borrar
            </button>
                    
                </div>
                
            </div>
</div>

        
      ))} */}
      
      {/* <div className='text-left'>
      
      <button type="button" className='inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1' onClick={handleAddFields}>
        Agregar Cirujano
      </button>
      </div> */}
            
            <div className="bg-[#437cdc] mt-3">
                <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl">
                Datos Preoperatorios
                </label>
              </div>
            
            <div className="flex py-1 text-left">
                                <div className="w-full  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Entidad Aseguradora
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            onFocus={cirugiaEntidadAseguradora}
                                            defaultValue={dataChildEntidadAseguradora.MENNIT}
                                            type="text"
                                            name='nombreEPSEntidadAseguradora'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            defaultValue={dataChildEntidadAseguradora.MENOMB}
                                            disabled={true}
                                            type="text"
                                            name='nEPS'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                </div>
                                
            </div>
            <div className="flex py-2 text-left">
                                <div className="w-1/3  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Lateralidad
                                    </label>
                                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    aria-label="Default select example" 
                                    onChange={handleOnchangeLateralidad}
                                    value={lateralidadUser}
                                    //value={dataUser.ProLat}
                                    name='lateralidad'>
                                        <option value=" ">Sin seleccionar</option>
                                        <option value="D">Derecho</option>
                                        <option value="I">Izquierdo</option>
                                        <option value="B">Bilateral</option>
                                        <option value="N">No aplica</option>
                                    </select>
                                </div>
                                <div className="w-1/3 px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Req Valoración Preanestésica?
                                    </label>
                                    <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" 
                                    type="checkbox" 
                                    name= 'valoracionPreanestesica'
                                    id="flexCheckDefault"
                                    checked={reqValoracionPreanestesica}
                                    onChange={handleOnchangeReqValoracionPreanestesica}
                                    />
                                </div>
                                <div className="w-1/3  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Tipo de Anestesia
                                    </label>
                                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    aria-label="Default select example" 
                                    //name = 'tipoDeAnestesia'
                                    value={tipoDeAnestesiaUser}
                                    onChange = {handleOnchangeTipoDeAnestesia}
                                    >                                        
                                        <option value="1">GENERAL</option>
                                        <option value="2">LOCAL</option>
                                        <option value="3">EPIDURAL</option>
                                        <option value="4">SEDACIÓN</option>
                                    </select>
                                </div>                          
            </div>
            <div className="flex py-2 text-left">
                                <div className="w-1/3  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Estado del Paciente
                                    </label>
                                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    aria-label="Default select example" 
                                    onChange={handleOnchangeEstadoDelPaciente}
                                    value={estadoDelPacienteUser}>
                                        <option value="0">Sin seleccionar</option>
                                        <option value="1">Vivo</option>
                                        <option value="2">Rescate</option>
                                        <option value="3">Cuidados intensivos</option>
                                        <option value="4">Conciente</option>
                                        <option value="5">Semiconciente</option>
                                        <option value="6">Inconciente</option>
                                    </select>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                            {estadoPacienteError}
                                    </label>
                                </div>
                                <div className="w-2/3  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        DX Preoperatorio
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={dataUser.ProDxppal}
                                            defaultValue={dataChildPreoperatorio.DMCodi}
                                            onFocus={cirugiaDXPreoperatorio}
                                            type="text"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            //defaultValue={dataUser.ProDN1}
                                            defaultValue={dataChildPreoperatorio.DMNomb}
                                            disabled={true}
                                            type="text"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                        
                                    </div>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                            {errorDxPreoperatorio}
                                    </label>
                                </div>
            </div>
            <div className="bg-[#437cdc] mt-3">
                <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl">
                Preparación de la Cirugía:
                </label>
              </div>
            
            <div className="flex px-1 py-1 text-left">
                <div className="w-1/3 ">
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                        Reserva Cama? 
                    </label>
                    <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" 
                    type="checkbox" 
                    id="flexCheckDefault" 
                    onChange={handleOnchangeReservaDeCama}
                    checked={reservaCama}/>
                </div>
                <div className="w-1/3 px-1">
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                        Req. Materiales Especiales?
                    </label>
                    <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" id="flexCheckDefault" 
                    onChange={handleOnchangeReqMateEspeciales}
                    checked={reqMaterialesEspeciales}/>
                </div>
                <div className="w-1/3 ">
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                        Req. Disp. Equipos Especiales?
                    </label>
                    <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" id="flexCheckDefault" 
                    onChange={handleOnchangeReqDispEquiposEspeciales}
                    checked={reqDispEquiposEspeciales}
                    //defaultChecked={reqDispEquiposEspeciales}
                    />
                </div>
            </div>
            <div className="flex px-1  text-left">
                <div className="w-1/3 ">
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                        Tipo de Cama CX 
                    </label>
                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                     value={tipoCamaDxUser} 
                    onChange={handleOnchangeTipoDeCamaCX}
                     disabled={!reservaCama}>
                        <option value=" ">Sin seleccionar</option>
                        <option value="H">Hospitalización</option>
                        <option value="U">UCI</option>
                        <option value="I">UCI Intermedio</option>                    
                    </select>
                </div>
                <div className="w-1/3 px-1">    
                    <textarea
                    onChange={handleOnchangeReqMaterialesEspecialesTextArea}
                    value={reqDispEquiposEspecialesTextArea}
                    disabled={!reqMaterialesEspeciales}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder=""
                    ></textarea>
                </div>
                <div className="w-1/3">    
                    <textarea
                    disabled={!reqDispEquiposEspeciales}
                    onChange={handleOnchangeReqDispEquiposEspcialesUser}
                    value={reqDispEquiposEspecialesUserTextArea}
                    //defaultValue={dataUser.ProObsEE}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder=""
                    ></textarea>
                </div>
            </div>
            <div className='px-1'>
                <div className="w-1/3 ">    
                    <textarea
                    onChange={handleOnchangeTextAreaTipoDeCamaCx}
                    value={tipoCamaCXTextAreaUser}
                    //defaultValue={dataUser.ProObRCam}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder=""
                    ></textarea>
                </div>
            </div>
            {/* <div className='px-1 py-2 text-left'>
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                    Dieta:
                    
                </label>
            </div> */}
            <div className='flex'>            
                <div className='flex px-0.5  text-left w-1/3 '>
                    {/* <div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Ninguna
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" 
                            type="checkbox" 
                            name='ningunaDieta'
                            //checked={isChecked}
                            checked={isCheckedNinguna}
                            onChange={handleOnChangeNinguna}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Blanda
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                            onChange={handleOnchangeDieta}
                            checked={blanda}
                            
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Líquida
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                            onChange={handleOnchangeDietaLiquida}
                            checked={liquida}
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Corriente
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                             onChange={handleOnchangeDietaCorriente}
                             checked={corriente}
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Hiposódica
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                            onChange={handleOnchangeDietaHiposodica}
                            checked={hiposodica}
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Ayuno
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                            onChange={handleOnchangeDietaAyuno}
                            checked={ayuno}
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Enema Evacuador
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            onChange={handleOnchangeDietaEnema}
                            checked={enemaEvacuador}
                            id="flexCheckDefault"/>
                        </div>
                    </div> */}
                    {/* <div className='px-0.5'>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Premedicación
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            onChange={handleOnchangePremedicacion}
                            checked={premedicacion}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                6 Horas Antes
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            onChange={handleOnchangeSeisHorasAntes}
                            checked={seisHorasAntes}
                             disabled={validacionesDisabledHoraSeis}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                8 Horas Antes
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            onChange={handleOnchangeOchoHorasAntes}
                            checked={ochoHorasAntes}
                             disabled={validacionesDisabledHoraOcho}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                12 Horas Antes
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            onChange={handleOnchangeDoceHorasAntes}
                            checked={doceHorasAntes}
                             disabled={validacionesDisabledHoraDoce}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                24 Horas Antes
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            onChange={handleOnchangeVeintiCuatroHorasAntes}
                            checked={veinteCuatroHorasAntes}
                             disabled={validacionesDisabledHoraVeintiCuatro}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Acompañante
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            onChange={handleOnchangeAcompanante}
                            checked={acompanante}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Rasurada
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            onChange={handleOnchangeRasurada}
                            checked={rasurada}
                            id="flexCheckDefault"/>
                        </div>
                    </div> */}
                </div>
                <div className=" px-1  text-left w-1/3 ">
                    <div className=" ">
                        {/* <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                            Dieta:
                        </label> */}
                        
                        
                        {/* <div className='pt-2'>
                            <textarea
                            onChange={handleOnchangeDietaTextArea}
                            
                            value={textAreaDieta}
                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                                transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            id="exampleFormControlTextarea1"
                            rows="4"
                            placeholder=""
                            ></textarea>
                        </div> */}
                        <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                            Obs. Quirurgicas
                        </label>
                        <div className=''>
                            <textarea
                            onChange={handleOnchangeObsQuirurgicas}
                            value={obsQuirurgicas}
                            //defaultValue={dataUser.ProObsT}
                            //defaultValue={dataUser.ProOBs1}
                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                                transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            id="exampleFormControlTextarea1"
                            rows="3"
                            placeholder=""                            
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div className=" px-1  text-left w-1/3 ">
                    <div className="">
                        {/* <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                            Hemoderivados
                        </label> */}
                        {/* <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" id="flexCheckDefault"
                        onChange={handleOnchangeHemoderivados}
                            checked={hemoderivadosChe}
                        /> */}
                    </div>
                    {/* <div className='flex'>
                    <button className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    disabled={!hemoderivadosChe}
                    
                    type='button'>^</button>
                    <div className='pl-2'>
                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    disabled={!hemoderivadosChe}
                    
                                            aria-label="Default select example" >
                            <option ></option>
                                           
                    </select>
                    </div>
                    
                    
                    </div> */}
                    
                    {/* <div className='flex'>
                        <div>
                            <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                Cantidad
                            </label>
                            <input
                               
                              disabled={!hemoderivadosChe}
                              onChange={handleOnchangeCantidad}
                              value={cantidadUser}
                              
                                type="number"
                                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                id="exampleFormControlInput1"
                                placeholder=""
                                />
                        </div>                        
                        <div className="pl-2">                            
                        <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                Vol. mL
                            </label>
                            <input
                            
                            onChange={handleOnchangeVolmL}
                            disabled={!hemoderivadosChe}
                            value={volmLUsuser}
                            
                            type="number"
                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                            id="exampleFormControlInput1"
                            placeholder=""
                            />
                        </div>
                    </div> */}
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                    Observaciones
                    </label>
                    <div className="">    
                        <textarea
                        value={observacionesUser}
                        onChange={handleOnchangeObservaciones}
                        //defaultValue={dataUser.ProObsHD}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                            transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        id="exampleFormControlTextarea1"
                        rows="4"
                        placeholder=""
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
        
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button type="button"
            onClick={handleCancelClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal">
            Cancelar
            </button>
            <button type="submit"
            //onClick={handleClickDataCirugia}
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Guardar
            </button>
        </div>
        </form>
        </div>
        <div className="flex-auto overflow-y-auto relative ">
        <div className={openTab === 2 ? "block" : "hidden"} id="link2">        
            <ModalProcedimiento idCirugia = {user.ProCirCod} user={user} passDataActualizaTablaPacientes={passDataActualizaTablaPacientes}/>     
                  
        </div>
        </div>
        {/* </>
)}  */}

        </div>
            
    </div>
    {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }       
        </div>
        
        {modalOnCirujanoCargo && < ModalCirujanoCargo setModalOnCirujanoCargo={setModalOnCirujanoCargo} 
        setChoiceCirujanoCargo={setChoiceCirujanoCargo}  passCirujanoACar={passCirujanoACar}/>} 

        {modalOnCirugiaQuirofano && < ModalCirugiaQuirofano setModalOnCirugiaQuirofano={setModalOnCirugiaQuirofano} setChoicerCirugiaQuirofano={setChoicerCirugiaQuirofano} passQuiro={passQuiro}/>}

        {modalOnCirugiaReservadoPor && < ModalCirugiaReservadoPor setModalOnCirugiaReservadoPor={setModalOnCirugiaReservadoPor} setChoiceCirugiaReservadoPor={setChoiceCirugiaReservadoPor} passReservado={passReservado}/>} 

        {modalOnCirugiaEntidadAseguradora && < ModalEntidadAseguradora setModalOnCirugiaEntidadAseguradora={setModalOnCirugiaEntidadAseguradora} setChoiceCirugiaEntidadAseguradora={setChoiceCirugiaEntidadAseguradora} nombre={dataUser.MPNOMC} tipoDocumento={dataUser.MPTDoc} numeroDocumento={dataUser.MPCedu} passDataEntidadAseguradora={passDataEntidadAseguradora}/>}

        {modalOnCirugiaPalabraClave && < ModalCirugiaPalabraClave setChoiceCirugiaPalabraClave={setChoiceCirugiaPalabraClave} setModalOnCirugiaPalabraClave={setModalOnCirugiaPalabraClave}/>}

        {modalOnCirugiaHemoderivados && < ModalHemoderivados setChoiceCirugiaHemoderivados={setChoiceCirugiaHemoderivados} setModalOnCirugiaHemoderivados={setModalOnCirugiaHemoderivados}/>} 

        {modalOnCirugiaDXPreoperatorio && < ModalCirugiaDXPreoperatorio passDataPrepa={passDataPrepa} setModalOnCirugiaDXPreoperatorio={setModalOnCirugiaDXPreoperatorio} setChoiceCirugiaDXPreoperatorio={setChoiceCirugiaDXPreoperatorio}/>} 

        {modalOnCirugiaReservadoPorEspecialidad && < ModalCirugiaReservadoPorEspecialidad setModalOnCirugiaReservadoPorEspecialidad={setModalOnCirugiaReservadoPorEspecialidad} setChoiceCirugiaReservadoPorEspecialidad={setChoiceCirugiaReservadoPorEspecialidad}
        passReservadoPorEspecialidad={passReservadoPorEspecialidad} dataChildReservadorPor={dataChildReservadorPor}/>}

        {modalOnCirugiaCirujanoCargoEspecialidad && < ModalCirugiaCirujanoCargoEspecialidad setChoiceCirugiaCirujanoCargoEspecialidad={setChoiceCirugiaCirujanoCargoEspecialidad} setModalOnCirugiaCirujanoCargoEspecialidad={setModalOnCirugiaCirujanoCargoEspecialidad}
        dataChildCirujanoACargo={dataChildCirujanoACargo} passCirujanoACargoEspecialidad={passCirujanoACargoEspecialidad}
        />} 

        {guardadoExitosamente? <SuccessFul setGuardadoExitosamente={setGuardadoExitosamente} setChoice={setChoice}  setModalOn={setModalOn} passDataActualizaTablaPacientes={passDataActualizaTablaPacientes} setOpenTab={setOpenTab}/>:null}

        {modalOnErrorCirugia? <ErrorCirugia setmodalOnErrorCirugia={setmodalOnErrorCirugia} quirofanoUserError={quirofanoUserError} horaFinalUserError={horaFinalUserError} horaInicialUserError={horaInicialUserError}
        opcionUserError={opcionUserError} codigoCirujanoCargoUserError={codigoCirujanoCargoUserError} estadoPacienteError={estadoPacienteError} errorFechaI={errorFechaI} errorFechaF={errorFechaF} errorDxPreoperatorio={errorDxPreoperatorio} errorDataQuirofanosOcupados={errorDataQuirofanosOcupados} errorReservadoPor={errorReservadoPor} dataHorariosQuirofanos={dataHorariosQuirofanos}/>:null}
    
        {modalOnOtroCirujanoCargo? <ModalOtroCirujanoCargo setmodalOnOtroCirujanoCargo={setmodalOnOtroCirujanoCargo} passDataOtroCirujanoCargo={passDataOtroCirujanoCargo}/>:null}
        {modalOnOtraEspecialidad? <ModalOtroCirujanoCargoEspecialidad setmodalOnOtraEspecialidad={setmodalOnOtraEspecialidad} dataOtroCirujanoCargo={dataOtroCirujanoCargo} passDataEspecialidadOtroCirujanoACargo={passDataEspecialidadOtroCirujanoACargo}/>:null}
    </>
  )
}

export default function ModalCirugia({ setModalOn, setChoice, user,passDataActualizaTablaPacientes }){
    return <ModalCirugiaTabs setModalOn={setModalOn} setChoice={setChoice} user={user} color='blue' passDataActualizaTablaPacientes={passDataActualizaTablaPacientes}/>
}